<template>
  <div>
    <spinner-loader :loadingStuff="loadingStuff" />
    <app-template />
    <div class="uk-container uk-container-large">
      <div class="intro-header">
        <div class="header-buttons">
          <div v-if="selectedUserValue !== ''">
            <div class="user-photo-info">
              <img v-if="
                selectedUserValue.userImage !== '' &&
                selectedUserValue.userImage !== null
              " id="user_photo" :src="getImgUrl(selectedUserValue.userImage)" alt="" />
              <TenantLogo v-else logo-class="login-logo" />
              <h1>
                Coach <br />
                {{ selectedUserValue.name }}
              </h1>
            </div>
          </div>
          <h2 v-else>Coaches</h2>
        </div>
      </div>

      <template v-if="selectedUserValue !== ''">
        <ul class="tabs headding-space">
          <li class="tab-item">
            <a :class="selectedTab === 'contact-tab' ? 'tab-link active' : 'tab-link'
              " @click="tabChange('selectedTab', 'contact-tab')" href="javascript:;">Contact information</a>
          </li>
          <li class="tab-item">
            <a :class="selectedTab === 'qualifications-tab'
              ? 'tab-link active'
              : 'tab-link'
              " @click="tabChange('selectedTab', 'qualifications-tab')" href="javascript:;">Qualifications</a>
          </li>
          <li class="tab-item">
            <a :class="selectedTab === 'targets-tab' ? 'tab-link active' : 'tab-link'
              " @click="tabChange('selectedTab', 'targets-tab')" href="javascript:;">Targets</a>
          </li>
          <li class="tab-item">
            <a :class="selectedTab === 'documents-tab' ? 'tab-link active' : 'tab-link'
              " @click="tabChange('selectedTab', 'documents-tab')" href="javascript:;">Documents</a>
          </li>
          <li class="tab-item">
            <a :class="selectedTab === 'teams-tab' ? 'tab-link active' : 'tab-link'
              " @click="tabChange('selectedTab', 'teams-tab')" href="javascript:;">Teams</a>
          </li>
          <!---<li class="tab-item">
            <a
              :class="
                selectedTab === 'performace-tab'
                  ? 'tab-link active'
                  : 'tab-link'
              "
              @click="tabChange('selectedTab', 'performace-tab')"
              href="javascript:;"
              >Performace</a
            >
          </li>-->
        </ul>

        <div class="tabs-wrapper">
          <div class="current-week-tab tab-content" v-if="selectedTab === 'performace-tab'"></div>

          <div class="current-week-tab tab-content" v-if="selectedTab === 'contact-tab'">
            <div class="games-info">
              <div class="personal-info">
                <div class="user-photo-info">
                  <img v-if="
                    selectedUserValue.coachImage !== '' &&
                    selectedUserValue.coachImage !== null
                  " :src="getImgUrl(selectedUserValue.coachImage)" alt="" />
                  <TenantLogo v-else logo-class="login-logo" />
                </div>
                <div class="item">
                  <span class="label">Name:</span>
                  <span class="value">{{ selectedUserValue.name }}</span>
                </div>
                <div class="item">
                  <span class="label">Email:</span>
                  <span class="value">{{ selectedUserValue.email }}</span>
                </div>

                <div class="item">
                  <span class="label">Phone:</span>
                  <span class="value">{{ selectedUserValue.phone }}</span>
                </div>

                <div class="item">
                  <span class="label">Address:</span>
                  <span class="value">{{ selectedUserValue.address }}</span>
                </div>

                <div class="item">
                  <span class="label">Postcode:</span>
                  <span class="value">{{ selectedUserValue.post_code }}</span>
                </div>

                <div class="item" v-html="selectedUserValue.details" />

                <b-button @click="editPlayerProfileInSettings()" class="main-button" size="lg"
                  variant="outline-warning">Edit profile</b-button>
              </div>
            </div>
          </div>

          <div class="team-over-veiw-tab tab-content" v-if="selectedTab === 'documents-tab'">
            <div class="tab-content">
              <div class="games-info">
                <h4>Create documents</h4>

                <b-button v-if="
                  userData.userType === 'Admin' ||
                  userData.userType === 'Coach'
                " @click="codeOfConductModal()" size="lg" class="main-button" variant="outline-success"><i
                    class="bi bi-clipboard" aria-hidden="true"></i> New Code
                  of conduct</b-button>
                <b-button v-if="
                  userData.userType === 'Admin' ||
                  userData.userType === 'Coach'
                " @click="selfDeclarationModal()" size="lg" class="main-button" variant="outline-success"><i
                    class="bi bi-clipboard" aria-hidden="true"></i> New self
                  declaration</b-button>

                <h4>View documents</h4>

                <div class="grid-list">
                  <b-button @click="gridListSwitch('grid')" size="lg" variant="outline-secondary" v-b-tooltip.hover
                    title="Grid view"><i class="bi bi-grid" aria-hidden="true"></i></b-button>

                  <b-button @click="gridListSwitch('list')" size="lg" variant="outline-secondary" v-b-tooltip.hover
                    title="List view"><i class="bi bi-list-task" aria-hidden="true"></i></b-button>
                </div>

                <div :class="gridListView === 'grid'
                  ? 'signed-documents-to-pdf  grid-view-wrapper'
                  : 'signed-documents-to-pdf list-view-wrapper'
                  ">
                  <div :class="gridListView === 'grid' ? 'document' : 'list'"
                    v-for="codDocument in allCodeOfConductSignatures" :key="codDocument.id" v-b-tooltip.hover :title="`Code of conduct ${formatDateForHuman(
                      codDocument.created_date,
                    )}`">
                    <img src="../img/documentlib.svg" />
                    <h3>
                      Code of conduct -
                      {{ formatDateForHuman(codDocument.created_date) }}
                    </h3>

                    <div class="doc-buttons">
                      <i class="bi bi-trash" @click="removeUploadedDocument(codDocument.id)" aria-hidden="true"></i>
                      <a target="_blank"><i class="bi bi-eye" @click="produceSelfCodPDF(codDocument)"
                          aria-hidden="true"></i></a>
                    </div>
                  </div>
                  <div :class="gridListView === 'grid' ? 'document' : 'list'"
                    v-for="document in selfDeclarationDocuments" :key="document.id" v-b-tooltip.hover :title="`Self Declaration ${formatDateForHuman(
                      document.created_date,
                    )}`">
                    <img src="../img/documentlib.svg" />
                    <h3>
                      Self Declaration -
                      {{ formatDateForHuman(document.created_date) }}
                    </h3>

                    <div class="doc-buttons">
                      <i class="bi bi-trash" @click="removeUploadedDocument(document.id)" aria-hidden="true"></i>
                      <a target="_blank"><i class="bi bi-eye" @click="produceSelfDeclarationPDF(document)"
                          aria-hidden="true"></i></a>
                    </div>
                  </div>
                </div>

                <div :class="gridListView === 'grid'
                  ? 'signed-documents-to-pdf  grid-view-wrapper'
                  : 'signed-documents-to-pdf list-view-wrapper'
                  ">
                  <div :class="gridListView === 'grid' ? 'document' : 'list'" v-for="document in uploadedDocuments"
                    :key="document.id" v-b-tooltip.hover :title="removeNumberFromStart(document.name)">
                    <img src="../img/documentlib.svg" />
                    <h3>{{ removeNumberFromStart(document.name) }}</h3>

                    <div class="doc-buttons">
                      <i class="bi bi-trash" @click="
                        removeUploadedDocument(document.id, document.name)
                        " aria-hidden="true"></i>
                      <a :href="getDocumentUrl(document.url)" target="_blank"><i class="bi bi-eye" 
                          aria-hidden="true"></i></a>
                    </div>
                  </div>
                </div>

                <div class="job-description">
                  <h4>Job Description</h4>
                  <p>
                    Your current role: {{ selectedUserValue.position }}, Please
                    view and sign your Job Description declaration
                  </p>

                  <b-button @click="jobDescriptionModal()" size="lg" class="main-button" variant="outline-success"><i
                      class="bi bi-clipboard" aria-hidden="true"></i> Job
                    Description</b-button>
                </div>
              </div>
            </div>
          </div>

          <div class="team-over-veiw-tab tab-content" v-if="selectedTab === 'teams-tab'">
            <div class="tab-content" v-if="clubTeams.length > 0">
              <div class="number-of-results">
                <p>Number of teams: {{ clubTeams.length }}</p>
              </div>

              <div v-for="(team, index) in clubTeams" :value="team.id + index" :key="team.id"
                class="team-profile-details" @click="setSelectedTeam(team)">
                <div class="user-photo-info">
                  <TenantLogo id="main-logo" logo-class="" />
                </div>
                <div class="team-info">
                  <h2>{{ team.teamName }}</h2>
                  <p>Age group: {{ team.age_group }}</p>
                </div>
                <span class="team-form-results" v-if="
                  allTeamsGameResultsData.length > 0 &&
                  userData.userType !== 'User'
                ">
                  <span v-for="(pastGame, i) in allTeamsGameResultsData" :key="i">
                    <span v-if="team.id == pastGame.teamId" :class="`result-${checkGameResult(pastGame)}`">{{
                      checkGameResult(pastGame) }}</span>
                  </span>
                </span>
                <span v-else>No game results</span>
              </div>
            </div>
            <div class="empty-state" v-else>
              <img src="../img/emptyStateIllustration.svg" />
              <p>No teams information</p>
            </div>
          </div>

          <div class="current-week-tab tab-content" v-if="selectedTab === 'targets-tab'">
            <div class="games-info">
              <div class="player-game-targets">
                <div class="game-target">
                  <div class="in-possession">
                    <div class="targets">
                      <h4>Targets</h4>
                      <div v-for="target in coachGameTargetsData" :key="target.id">
                        <p class="target-outline">
                          <img src="./img/target.svg" alt="" />
                          <span v-html="target.target"></span> -
                          <span v-if="target.complete == 1">Complete</span><span v-else>Not complete</span>
                          <b-button size="lg" class="main-button" variant="outline-warning" v-b-tooltip.hover
                            title="Edit" @click="
                              performanceTargetsModal(
                                target,
                                'performanceTargetsModal',
                                'performance target',
                              )
                              "><i class="bi bi-pencil" aria-hidden="true"></i></b-button>
                        </p>
                      </div>
                      <p v-if="coachGameTargetsData.length === 0">
                        No Game targets.
                      </p>
                    </div>
                  </div>
                </div>

                <b-button size="lg" class="main-button" variant="outline-success" v-b-tooltip.hover
                  title="Add new Coach target" @click="
                    performanceTargetsModal(
                      {},
                      'performanceTargetsModal',
                      'performance target',
                    )
                    "><i class="bi bi-plus" aria-hidden="true"></i></b-button>
              </div>
            </div>
          </div>

          <div class="current-week-tab tab-content" v-if="selectedTab === 'qualifications-tab'">
            <div class="games-info">
              <div class="form__item qualifications-data">
                <div class="qualifications-wrapper">
                  <img src="./img/uefa-logo.jpg" alt="uefa logo" />
                  <h4>UEFA Qualifications / coaching licences</h4>

                  <p v-if="selectedcoachesQualifications.UEFA_A === 1">
                    <i class="bi bi-award" aria-hidden="true"></i> UEFA A
                  </p>
                  <p v-if="selectedcoachesQualifications.UEFA_B === 1">
                    <i class="bi bi-award" aria-hidden="true"></i> UEFA B
                  </p>
                  <p v-if="selectedcoachesQualifications.UEFA_C === 1">
                    <i class="bi bi-award" aria-hidden="true"></i> UEFA C
                  </p>
                  <p v-if="selectedcoachesQualifications.UEFA_C === 1">
                    <i class="bi bi-award" aria-hidden="true"></i> UEFA C
                  </p>
                  <p v-if="selectedcoachesQualifications.UEFA_Pro === 1">
                    <i class="bi bi-award" aria-hidden="true"></i> UEFA Pro
                  </p>
                  <p v-if="selectedcoachesQualifications.youth_A_Elite === 1">
                    <i class="bi bi-award" aria-hidden="true"></i> UEFA Youth A
                    Elite
                  </p>
                  <p v-if="selectedcoachesQualifications.youth_B_Elite === 1">
                    <i class="bi bi-award" aria-hidden="true"></i> UEFA Youth B
                    Elite
                  </p>
                  <p v-if="selectedcoachesQualifications.youth_B_Elite === 1">
                    <i class="bi bi-award" aria-hidden="true"></i> UEFA
                    Goalkeeper A
                  </p>
                  <p v-if="selectedcoachesQualifications.UEFA_Goalkeeper_A === 1">
                    <i class="bi bi-award" aria-hidden="true"></i> UEFA
                    Goalkeeper A
                  </p>
                  <p v-if="selectedcoachesQualifications.UEFA_Goalkeeper_B === 1">
                    <i class="bi bi-award" aria-hidden="true"></i> UEFA
                    Goalkeeper B
                  </p>
                  <p v-if="selectedcoachesQualifications.UEFA_Futsal_B === 1">
                    <i class="bi bi-award" aria-hidden="true"></i> UEFA Futsal B
                  </p>

                  <h4>Coaching experience</h4>
                  <div v-html="selectedcoachesQualifications.details"></div>
                </div>

                <div class="numbers-dates">
                  <img src="./img/sfa-logo.jpg" alt="sfa logo" />
                  <h4>Certificates and memberships</h4>

                  <p>
                    Pvg scheme membership number
                    <span v-if="selectedcoachesQualifications.PVG_number !== null">{{
                      selectedcoachesQualifications.PVG_number }}</span>
                    <span v-else class="red-warning">Please add membership number</span>
                  </p>

                  <p>
                    Pvg scheme issue date
                    <span v-if="
                      selectedcoachesQualifications.PVG_scheme_issue_date !==
                      null
                    ">{{
                      formatDateForHuman(
                        selectedcoachesQualifications.PVG_scheme_issue_date,
                      )
                    }}</span>
                    <span v-else class="red-warning">Please add issue date</span>
                  </p>

                  <p>
                    Pvg scheme update due date
                    <span v-if="
                      selectedcoachesQualifications.PVG_scheme_due_date !==
                      null
                    ">{{
                      formatDateForHuman(
                        selectedcoachesQualifications.PVG_scheme_due_date,
                      )
                    }}</span>
                    <span v-else class="red-warning">Please add due date</span>
                  </p>

                  <p>
                    Disclosure certificate number
                    <span v-if="
                      selectedcoachesQualifications.disclosure_certificate_number !==
                      null
                    ">{{
                      selectedcoachesQualifications.disclosure_certificate_number
                    }}</span>
                    <span v-else class="red-warning">Please add certificate number</span>
                  </p>

                  <p>
                    Child wellbeing certificate training completed
                    <span v-if="
                      selectedcoachesQualifications.child_wellbeing_certificate_completed !==
                      null
                    ">{{
                      formatDateForHuman(
                        selectedcoachesQualifications.child_wellbeing_certificate_completed,
                      )
                    }}</span>
                    <span v-else class="red-warning">Please add issue date</span>
                  </p>

                  <p>
                    Child wellbeing certificate training (due date)
                    <span v-if="
                      selectedcoachesQualifications.child_wellbeing_certificate_due_date !==
                      null
                    ">{{
                      formatDateForHuman(
                        selectedcoachesQualifications.child_wellbeing_certificate_due_date,
                      )
                    }}</span>
                    <span v-else class="red-warning">Please add due date</span>
                  </p>

                  <p>
                    First aid training completed
                    <span v-if="
                      selectedcoachesQualifications.first_aid_completed !==
                      null
                    ">{{
                      formatDateForHuman(
                        selectedcoachesQualifications.first_aid_completed,
                      )
                    }}</span>
                    <span v-else class="red-warning">Please add completed date</span>
                  </p>
                  <p class="first-aid-cert-image" v-if="
                    selectedcoachesQualifications.first_aid_image_url !== null
                  ">
                    First aid certificate pdf
                    <img :src="getImgUrl(
                      selectedcoachesQualifications.first_aid_image_url,
                    )
                      " alt="" />
                    <a target="_blank" :href="getImgUrl(
                      selectedcoachesQualifications.first_aid_image_url,
                    )
                      ">view full size image</a>
                  </p>

                  <p>
                    First aid training (due date)
                    <span v-if="
                      selectedcoachesQualifications.first_aid_due_date !==
                      null
                    ">{{
                      formatDateForHuman(
                        selectedcoachesQualifications.first_aid_due_date,
                      )
                    }}</span>
                    <span v-else class="red-warning">Please add due date</span>
                  </p>
                </div>

                <div class="continuous-professional-development">
                  <img src="./img/sfa-logo.jpg" alt="sfa logo" />
                  <h4>Continuous professional development (CPD)</h4>

                  <div class="cpd-item-wrapper" v-if="cpdData.length > 0">
                    <div class="cpd-item" v-for="item in cpdData" :key="item.id">
                      <p>
                        {{ item.course_title }}
                        <span>{{ formatDateForHuman(item.date) }} -
                          {{ item.hours }} CPD hours</span>
                      </p>

                      <b-button @click="addEditCPDhModel('edit', item)" class="main-button" size="lg"
                        variant="outline-warning"><i class="bi bi-pencil" aria-hidden="true"></i></b-button>
                    </div>
                  </div>
                  <div class="empty-state" v-else>
                    <img src="../img/emptyStateIllustration.svg" />
                    <p>Please add CPD information</p>
                  </div>

                  <p class="total-hours">
                    Total hours: {{ getCPDTotalHours() }}
                  </p>
                  <p class="small-text">
                    You can change and up date this number when adding new CPD
                    information.
                  </p>

                  <b-button @click="addEditCPDhModel('add')" class="main-button" size="lg" variant="outline-success">Add
                    CPD attendance</b-button>
                </div>
              </div>

              <b-button @click="addEditCoachModel('Edit')" class="main-button" size="lg" variant="outline-warning">Edit
                qualifications</b-button>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div>
          <ul class="tabs">
            <li class="tab-item">
              <a :class="selectedCoachTab === 'coaches-tab'
                ? 'tab-link active'
                : 'tab-link'
                " @click="tabChange('selectedCoachTab', 'coaches-tab')" href="javascript:;">Coaches</a>
            </li>
            <li class="tab-item">
              <a :class="selectedCoachTab === 'information-tab'
                ? 'tab-link'
                : 'tab-link'
                " @click="tabChange('selectedCoachTab', 'information-tab')" href="javascript:;">Information</a>
            </li>
          </ul>
          <div class="tabs-wrapper">
            <div class="tab-content" v-if="selectedCoachTab === 'coaches-tab'">
              <section class="player-profile-wrapper" v-if="coachesData.length > 0">
                <div v-for="coach in coachesData" :value="coach.id" :key="coach.id" class="player-profile-details"
                  @click="selectedUseChanged(coach)">
                  <div class="user-photo-info">
                    <img v-if="coach.userImage !== '' && coach.userImage !== null" :src="getImgUrl(coach.userImage)"
                      alt="" />
                    <TenantLogo v-else id="main-logo" logo-class="" />
                  </div>
                  <div class="user-info">
                    <h2>{{ coach.name }}</h2>
                    <p>
                      <span v-if="coach.userType === 'Admin'">{{
                        coach.userType
                      }}</span>
                      / Coach
                    </p>
                  </div>
                </div>
              </section>
              <div class="empty-state" v-else>
                <img src="../img/emptyStateIllustration.svg" />
                <p>Please select a coach to view their information</p>
              </div>
            </div>

            <div class="tab-content" v-if="selectedCoachTab === 'information-tab'">
              <div class="coaches-missing-info">
                <div class="missing-certs">
                  <h3>Coaches Compliance Overview</h3>
                  <p>
                    Overview of certificates, memberships and contact details for all coaches.
                    Items highlighted in <span class="red-warning">red</span> are missing or expired,
                    <span class="amber-warning">amber</span> are expiring within 30 days,
                    and <span class="green-success">green</span> are complete.
                  </p>

                  <div v-if="coachComplianceSummary" class="compliance-summary">
                    <div class="compliance-stat">
                      <span class="stat-number">{{ coachComplianceSummary.totalCoaches }}</span>
                      <span class="stat-label">Total Coaches</span>
                    </div>
                    <div class="compliance-stat compliance-good">
                      <span class="stat-number">{{ coachComplianceSummary.fullyCompliant }}</span>
                      <span class="stat-label">Fully Compliant</span>
                    </div>
                    <div class="compliance-stat compliance-warning">
                      <span class="stat-number">{{ coachComplianceSummary.expiringSoon }}</span>
                      <span class="stat-label">Expiring Soon</span>
                    </div>
                    <div class="compliance-stat compliance-danger">
                      <span class="stat-number">{{ coachComplianceSummary.missingItems }}</span>
                      <span class="stat-label">Missing Items</span>
                    </div>
                  </div>

                  <div v-if="coachComplianceRows.length > 0" class="export-buttons" style="margin-bottom: 1rem;">
                    <button class="btn btn-outline-danger btn-sm" type="button" @click="exportCompliancePDF()">
                      <i class="bi bi-file-earmark-pdf"></i> Export PDF
                    </button>
                    <button class="btn btn-outline-success btn-sm" type="button" @click="exportComplianceCSV()">
                      <i class="bi bi-file-earmark-spreadsheet"></i> Export CSV
                    </button>
                  </div>

                  <div class="table-wrapper table-scroll">
                    <div v-if="coachComplianceRows.length > 0">
                      <vue-good-table
                        style-class="vgt-table bordered"
                        :columns="columnsCoachMissingData"
                        :rows="coachComplianceRows"
                        :search-options="{ enabled: true, placeholder: 'Search Coaches' }">
                        <template #table-row="props">
                          <span v-if="props.column.field === 'coach_name'">
                            {{ props.row.coach_name || 'Unknown' }}
                          </span>

                          <span v-else-if="props.column.field === 'coach_email'">
                            <span :class="props.row.coach_email ? 'green-success' : 'red-warning'">
                              {{ props.row.coach_email || 'Missing' }}
                            </span>
                          </span>

                          <span v-else-if="props.column.field === 'coach_phone'">
                            <span :class="props.row.coach_phone ? 'green-success' : 'red-warning'">
                              {{ props.row.coach_phone || 'Missing' }}
                            </span>
                          </span>

                          <span v-else-if="props.column.field === 'PVG_number'">
                            <span v-if="!props.row.PVG_number" class="red-warning">Missing</span>
                            <span v-else class="green-success">{{ props.row.PVG_number }}</span>
                            <br v-if="props.row.PVG_scheme_due_date" />
                            <small v-if="props.row.PVG_scheme_due_date"
                              :class="getExpiryClass(props.row.PVG_scheme_due_date)">
                              Due: {{ formatDateForHuman(props.row.PVG_scheme_due_date) }}
                            </small>
                          </span>

                          <span v-else-if="props.column.field === 'child_wellbeing_certificate_completed'">
                            <span v-if="!props.row.child_wellbeing_certificate_completed" class="red-warning">Missing</span>
                            <span v-else class="green-success">{{ props.row.child_wellbeing_certificate_completed }}</span>
                            <br v-if="props.row.child_wellbeing_certificate_due_date" />
                            <small v-if="props.row.child_wellbeing_certificate_due_date"
                              :class="getExpiryClass(props.row.child_wellbeing_certificate_due_date)">
                              Due: {{ formatDateForHuman(props.row.child_wellbeing_certificate_due_date) }}
                            </small>
                          </span>

                          <span v-else-if="props.column.field === 'disclosure_certificate_number'">
                            <span v-if="!props.row.disclosure_certificate_number" class="red-warning">Missing</span>
                            <span v-else class="green-success">{{ props.row.disclosure_certificate_number }}</span>
                          </span>

                          <span v-else-if="props.column.field === 'first_aid_completed'">
                            <span v-if="!props.row.first_aid_completed" class="red-warning">Not completed</span>
                            <span v-else class="green-success">{{ formatDateForHuman(props.row.first_aid_completed) }}</span>
                            <br v-if="props.row.first_aid_due_date" />
                            <small v-if="props.row.first_aid_due_date"
                              :class="getExpiryClass(props.row.first_aid_due_date)">
                              Due: {{ formatDateForHuman(props.row.first_aid_due_date) }}
                            </small>
                          </span>

                          <span v-else-if="props.column.field === 'first_aid_image_url'">
                            <span v-if="!props.row.first_aid_image_url" class="red-warning">No certificate uploaded</span>
                            <span v-else class="green-success">Uploaded</span>
                          </span>

                          <span v-else-if="props.column.field === 'coaching_badges'">
                            <span v-if="props.row.coaching_badges === 'None'" class="red-warning">None</span>
                            <span v-else class="green-success">{{ props.row.coaching_badges }}</span>
                          </span>

                          <span v-else-if="props.column.field === 'missing_count'">
                            <span :class="props.row.missing_count === 0 ? 'green-success' : 'red-warning'"
                              style="font-weight: bold;">
                              {{ props.row.missing_count }}
                            </span>
                          </span>
                        </template>
                      </vue-good-table>
                    </div>
                    <div v-else>
                      <div class="empty-state">
                        <img src="../img/emptyStateIllustration.svg" />
                        <p>No coach data available. Coaches need to sign in and view their profile.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <b-modal v-if="showMakeCodPDFModal" v-model="showMakeCodPDFModal" modal-class="modal-fullscreen" size="xl"
      :hide-footer="true">
      <div class="player-report-content">
        <iframe id="theCodPDF_preview" src="" />
      </div>
    </b-modal>
    <b-modal v-if="showMakeSelfDeclarationPDFModal" v-model="showMakeSelfDeclarationPDFModal"
      modal-class="modal-fullscreen" size="xl" :hide-footer="true">
      <div class="player-report-content">
        <iframe id="theSelfDeclarationPDF_preview" src="" />
      </div>
    </b-modal>
    <b-modal v-if="showPerformanceTargetsModal" v-model="showPerformanceTargetsModal" size="lg" :hide-footer="true">
      <div class="performance-target-modal-content">
        <h3>
          <span v-if="selectedPerformanceTarget.edit === false">Add</span>
          <span v-else>Edit</span>
          Coach performance target
        </h3>
        <p class="small-date-player-coach">
          {{ formatDateForHuman(selectedPerformanceTarget.created_date) }}
        </p>

        <QuillEditor v-model:content="selectedPerformanceTarget.target" contentType="html" theme="snow" />
        <b-form-checkbox id="checkbox-2" size="lg" v-model="selectedPerformanceTarget.complete" name="checkbox-2"
          value="1" unchecked-value="0">Mark target as complete
        </b-form-checkbox>

        <div v-if="selectedPerformanceTarget.edit === true" class="buttons-row">
          <b-button @click="updatePerformanceReportTarget()" size="lg" variant="outline-success">
            Update</b-button>

          <b-button @click="deletePerformanceReportTarget()" size="lg" variant="outline-danger">Delete</b-button>
        </div>
        <b-button v-else @click="addNewPerformanceReportTarget()" size="lg" variant="outline-success">
          Add</b-button>
      </div>
    </b-modal>

    <b-modal v-if="showAddEditCPD" v-model="showAddEditCPD" size="lg" :title="editMode === false ? 'Add CPD information' : 'Edit CPD information'
      " :hide-footer="true">
      <div class="form__item">
        <label class="form__label" for="title">Title</label>

        <b-form-input id="title" v-model="selectedCPDData.course_title"></b-form-input>
      </div>

      <div class="form__item">
        <label class="form__label" for="sessionDetails">Information</label>
        <QuillEditor v-model:content="selectedCPDData.course_information" contentType="html" theme="snow" />
      </div>

      <div class="form__item">
        <label class="form__label" for="pvg-scheme-membership-number">Date attended / start date</label>

        <VueDatePicker :locale="'en-GB'" v-model="selectedCPDData.date" format="dd/MM/yyyy" name="pvg-scheme-due-date"
          id="pvg-scheme-due-date" :enable-time-picker="false" />
      </div>

      <div class="form__item">
        <label class="form__label" for="hours">CPD Hours for this session</label>

        <b-form-input id="hours" type="number" v-model="selectedCPDData.hours"></b-form-input>
      </div>

      <div class="form__item">
        <label class="form__label" for="total_hours">Total CPD Hours (for current 3 year period) outstanding</label>

        <b-form-input id="total_hours" type="number" v-model="selectedCPDData.total_hours"></b-form-input>
      </div>

      <div v-if="editMode === false" class="form__item">
        <button @click="saveCPDinformation()" class="green-button">
          Add infromation
        </button>
      </div>
      <div v-else class="form__item">
        <button @click="editCPDinformation()" class="green-button">
          Edit infromation
        </button>
      </div>
    </b-modal>

    <b-modal v-if="showAddEditCoach" v-model="showAddEditCoach" size="lg"
      :title="editMode === false ? 'Add Qualifications' : 'Edit Qualifications'" :hide-footer="true">
      <div class="form__item">
        <label class="form__label" for="checkBoxes">UEFA Qualifications / coaching licences</label>
        <div class="wrapper-checkBoxes">
          <b-form-checkbox id="UEFA_A-checkBox" v-model="selectedcoachesQualifications.UEFA_A" name="UEFA_A-checkBox"
            value="1" unchecked-value="0">
            <span class="check-box-text">UEFA A</span>
          </b-form-checkbox>

          <b-form-checkbox id="UEFA_B-checkBox" v-model="selectedcoachesQualifications.UEFA_B" name="UEFA_B-checkBox"
            value="1" unchecked-value="0">
            <span class="check-box-text">UEFA B</span>
          </b-form-checkbox>

          <b-form-checkbox id="UEFA_C-checkBox" v-model="selectedcoachesQualifications.UEFA_C" name="UEFA_C-checkBox"
            value="1" unchecked-value="0">
            <span class="check-box-text">UEFA C</span>
          </b-form-checkbox>

          <b-form-checkbox id="UEFA_Pro-checkBox" v-model="selectedcoachesQualifications.UEFA_Pro"
            name="UEFA_Pro-checkBox" value="1" unchecked-value="0">
            <span class="check-box-text">UEFA Pro</span>
          </b-form-checkbox>

          <b-form-checkbox id="youth_A_Elite-checkBox" v-model="selectedcoachesQualifications.youth_A_Elite"
            name="youth_A_Elite-checkBox" value="1" unchecked-value="0">
            <span class="check-box-text">UEFA Youth A Elite</span>
          </b-form-checkbox>

          <b-form-checkbox id="youth_B_Elite-checkBox" v-model="selectedcoachesQualifications.youth_B_Elite"
            name="youth_B_Elite-checkBox" value="1" unchecked-value="0">
            <span class="check-box-text">UEFA Youth B Elite</span>
          </b-form-checkbox>

          <b-form-checkbox id="UEFA_Goalkeeper_A-checkBox" v-model="selectedcoachesQualifications.UEFA_Goalkeeper_A"
            name="UEFA_Goalkeeper_A-checkBox" value="1" unchecked-value="0">
            <span class="check-box-text">UEFA Goalkeeper A</span>
          </b-form-checkbox>

          <b-form-checkbox id="UEFA_Goalkeeper_B-checkBox" v-model="selectedcoachesQualifications.UEFA_Goalkeeper_B"
            name="UEFA_Goalkeeper_B-checkBox" value="1" unchecked-value="0">
            <span class="check-box-text">UEFA Goalkeeper B</span>
          </b-form-checkbox>

          <b-form-checkbox id="UEFA_Futsal_B-checkBox" v-model="selectedcoachesQualifications.UEFA_Futsal_B"
            name="UEFA_Futsal_B-checkBox" value="1" unchecked-value="0">
            <span class="check-box-text">UEFA Futsal B</span>
          </b-form-checkbox>
        </div>
      </div>

      <div class="form__item">
        <label class="form__label" for="sessionDetails">Coaching experience</label>
        <QuillEditor v-model:content="selectedcoachesQualifications.details" contentType="html" theme="snow" />
      </div>

      <h4>Certificates and memberships</h4>
      <div class="form__item">
        <label class="form__label" for="pvg-scheme-membership-number">Pvg scheme membership number</label>
        <b-form-input v-model="selectedcoachesQualifications.PVG_number" id="pvg-scheme-membership-number">
        </b-form-input>
      </div>

      <div class="form__item">
        <label class="form__label" for="pvg-scheme-membership-number">Pvg scheme issue date</label>

        <VueDatePicker :locale="'en-GB'" v-model="selectedcoachesQualifications.PVG_scheme_issue_date"
          name="pvg-scheme-issue-date" id="pvg-scheme-issue-date" format="dd/MM/yyyy" :enable-time-picker="false" />
      </div>

      <div class="form__item">
        <label class="form__label" for="pvg-scheme-membership-number">Pvg scheme update due date</label>

        <VueDatePicker :locale="'en-GB'" v-model="selectedcoachesQualifications.PVG_scheme_due_date"
          name="pvg-scheme-due-date" id="pvg-scheme-due-date" format="dd/MM/yyyy" :enable-time-picker="false" />
      </div>

      <div class="form__item">
        <label class="form__label" for="disclosure-membership-number">Disclosure certificate number</label>
        <b-form-input v-model="selectedcoachesQualifications.disclosure_certificate_number"
          id="disclosure-membership-number">
        </b-form-input>
      </div>

      <div class="form__item">
        <label class="form__label" for="child-wellbeing-date-complete">Child wellbeing certificate training
          completed</label>

        <VueDatePicker :locale="'en-GB'" v-model="selectedcoachesQualifications.child_wellbeing_certificate_completed
          " name="child-wellbeing-date-complete" format="dd/MM/yyyy" id="child-wellbeing-date-complete"
          :enable-time-picker="false" />
      </div>

      <div class="form__item">
        <label class="form__label" for="child-wellbeing-date-due-date">Child wellbeing certificate training (due
          date)</label>

        <VueDatePicker :locale="'en-GB'" v-model="selectedcoachesQualifications.child_wellbeing_certificate_due_date
          " name="child-wellbeing-date-due-date" format="dd/MM/yyyy" id="child-wellbeing-date-due-date"
          :enable-time-picker="false" />
      </div>

      <div class="form__item">
        <label class="form__label" for="first-aid-completed">First aid training completed</label>

        <VueDatePicker :locale="'en-GB'" v-model="selectedcoachesQualifications.first_aid_completed"
          name="first-aid-completed" id="first-aid-completed" format="dd/MM/yyyy" :enable-time-picker="false" />

        <div class="first-aid-image-upload" v-if="selectedcoachesQualifications.first_aid_completed !== null">
          <p>First aid certificate PDF photo</p>
          <ImageUploader @populateImageObjectFromUpload="imageUploadFileDataChnged($event)"
            @populateImageFileDataFromUpload="
              imageUploadObjectDataChanged($event)
              " @clearImageDataFromUpload="clearImageDataFromUpload()"
            :imageURL="selectedcoachesQualifications.first_aid_image_url" />
        </div>
      </div>

      <div class="form__item">
        <label class="form__label" for="first-aid-due-date">First aid training (due date)</label>

        <VueDatePicker :locale="'en-GB'" v-model="selectedcoachesQualifications.first_aid_due_date"
          name="first-aid-due-date" id="first-aid-due-date" format="dd/MM/yyyy" :enable-time-picker="false" />
      </div>

      <div v-if="editMode === false" class="form__item">
        <button @click="addCoachQualificationsSubmit()" class="green-button">
          Add Qualifications
        </button>
      </div>
      <div v-else class="form__item">
        <button @click="editCoachQualificationsSubmit()" class="green-button">
          Edit Qualifications
        </button>
      </div>
    </b-modal>

    <b-modal v-if="showAddHomeworkModal" v-model="showAddHomeworkModal" size="lg" :hide-footer="true">
      <h2>
        <span v-if="newHomeWorkData.id !== undefined">Edit</span><span v-else>Add</span> homework
      </h2>

      <div class="form__item">
        <label class="form__label" for="goals">Title</label>
        <b-form-input id="textarea" v-model="newHomeWorkData.title"></b-form-input>
      </div>

      <div class="form__item">
        <label class="form__label" for="goals">Information</label>
        <QuillEditor v-model:content="newHomeWorkData.information" contentType="html" theme="snow" />
      </div>

      <h4>Videos</h4>

      <b-button v-b-tooltip.hover title="Add video" @click="addVideo('homework')" variant="success">
        <i class="bi bi-plus" aria-hidden="true"></i>
      </b-button>

      <b-button v-if="newHomeWorkData.id !== undefined" @click="editHomework()" size="lg" variant="outline-success"><i
          class="bi bi-file-text" aria-hidden="true"></i> Edit game
        homework</b-button>

      <b-button v-else @click="saveHomework()" size="lg" variant="outline-success" :disabled="$store.getters.isReadOnlySeason"><i class="bi bi-file-text"
          aria-hidden="true"></i> Submit game
        homework</b-button>
    </b-modal>

    <b-modal v-if="showJobDescriptionModal" v-model="showJobDescriptionModal" modal-class="modal-fullscreen" size="xl"
      title="Job Description" :hide-footer="true">
      <div class="player-cv-content">
        <img class="team-logo" :src="getImgUrl('default-image.png')" alt="" />
        <div class="form__item">
          <div v-html="jobDescriptionData.text"></div>

          <div class="no-job-description" v-if="
            jobDescriptionData.text !==
            'No job description found for the specified job type.'
          ">
            <div class="show-signature" v-if="alljobDescriptionSignatures !== null">
              <h4>Signature</h4>
              <img :src="getImgUrl(alljobDescriptionSignatures.signature)" />
              <p>
                Date:
                {{
                  this.formatDateForHuman(
                    alljobDescriptionSignatures.created_date,
                  )
                }}
              </p>
            </div>
            <div v-else class="no-signature">
              <h4>Signature</h4>
              <p>Please sign below</p>
              <div class="signatureWrapper">
                <vueSignature ref="jobDescriptionSignature" :sigOption="signatureOptions" :w="'800px'" :h="'400px'"
                  :disabled="false">
                </vueSignature>

                <div class="player-game-responce">
                  <button @click="saveSignature('jobDescriptionSignature')">
                    Save
                  </button>
                  <button @click="clearSignature('jobDescriptionSignature')">
                    Clear
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal v-if="showCodeOfConductModal" v-model="showCodeOfConductModal" modal-class="modal-fullscreen" size="xl"
      title="Code of conduct" :hide-footer="true">
      <div class="player-cv-content">
        <div class="form__item">
          <div v-html="codeOfConductData.text"></div>

          <h4>Signature</h4>
          <p>Please sign below</p>
          <div class="signatureWrapper">
            <vueSignature ref="coachCOCSignature" :sigOption="signatureOptions" :w="'800px'" :h="'400px'"
              :disabled="false">
            </vueSignature>

            <div class="player-game-responce">
              <button @click="saveSignature('coachCOCSignature')">Save</button>
              <button @click="clearSignature('coachCOCSignature')">
                Clear
              </button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal v-if="showSelfDeclarationModal" v-model="showSelfDeclarationModal" modal-class="modal-fullscreen" size="xl"
      title="Self-declaration Form For Regulated Work With Children" :hide-footer="true">
      <div class="player-cv-content">
        <p>
          The Scottish FA / {{ setClubName() }} require that anyone applying to
          do regulated work with children, must complete a self-declaration form
          as part of the recruitment process. 'Regulated work with children'
          posts are exempt from the Rehabilitation of Offenders Act 1974 by the
          Exclusions and Exceptions Scotland Order 2010. Candidates are
          therefore required to disclose all convictions (spent and unspent),
          cautions, and any relevant non-conviction information. Please note
          that any information you give in this form will be managed according
          to the Scottish FA / {{ setClubName() }} Data Protection Policy.
          Having a criminal record will not necessarily bar you from working
          with us. This will depend on the circumstances and background of any
          offences and the nature of the position.
        </p>

        <p>Completing the form:</p>
        <ul>
          <li>
            1. Please give details regarding any convictions and cautions under
            the heading in Section 1.
          </li>
          <li>
            2. Please provide details of any disciplinary action in Section 2.
          </li>
          <li>
            3. Please give details of any relevant non-conviction information in
            Section 3.
          </li>
          <li>
            4. If you have no convictions, cautions, or relevant non-conviction
            information please go to Section 4 and sign the declaration in
            Section 5.
          </li>
          <li>
            5. Return the form in a sealed envelope marked 'Private and
            Confidential – Self Declaration'. Please do not put your completed
            application/registration form in the same envelope. It is important
            that the forms are kept separate. Your completed self-declaration
            form will only be seen by individual in the organisation who have a
            responsibility for recruiting staff and volunteers.
          </li>
        </ul>

        <section class="section-form-style">
          <h3>PERSONAL DETAILS</h3>
          <p class="info-details">
            If there are any personal details missing, please add them within
            the user setting section, under the staff tab -
            <router-link :to="{ name: 'Settings' }">Settings</router-link>
          </p>

          <div class="form__item">
            <label class="form__label" for="goals">Full Name:</label>
            <p>{{ selectedUserValue.name }}</p>
          </div>

          <div class="form__item">
            <label class="form__label" for="goals">Tel number:</label>
            <p>{{ selectedUserValue.phone }}</p>
          </div>

          <div class="form__item">
            <label class="form__label" for="goals">Email:</label>
            <p>{{ selectedUserValue.email }}</p>
          </div>

          <div class="form__item">
            <label class="form__label" for="goals">Address:</label>
            <p>{{ selectedUserValue.address }}</p>
          </div>

          <div class="form__item">
            <label class="form__label" for="goals">Post code:</label>
            <p>{{ selectedUserValue.post_code }}</p>
          </div>

          <div class="form__item">
            <label class="form__label" for="goals">Role Details:</label>
            <b-form-textarea id="address" v-model="selfDeclaration.role_details" placeholder=""
              rows="8"></b-form-textarea>
          </div>
        </section>

        <section class="section-form-style">
          <h3>Section 1 – Convictions and Cautions</h3>

          <b-form-group label="Do you have any convictions?">
            <b-form-radio v-model="selfDeclaration.offenceSelected" name="offence-radios" value="Yes">Yes</b-form-radio>
            <b-form-radio v-model="selfDeclaration.offenceSelected" name="offence-radios" value="No">No</b-form-radio>
          </b-form-group>

          <div class="" v-if="selfDeclaration.offenceSelected === 'Yes'">
            <div class="form__item">
              <label class="form__label" for="goals">a. Please give the date and details of the offence(s) with
                which you were charged, the sentence that you received and the
                court where your case(s) was heard.</label>
              <b-form-textarea id="offence" v-model="selfDeclaration.details_of_the_offences" placeholder=""
                rows="8"></b-form-textarea>
            </div>

            <div class="form__item">
              <label class="form__label" for="goals">b. Please give details of the reasons and circumstances that
                led to your offence(s).</label>
              <b-form-textarea id="circumstances" v-model="selfDeclaration.reasons_and_circumstances" placeholder=""
                rows="8"></b-form-textarea>
            </div>

            <div class="form__item">
              <label class="form__label" for="goals">c. Has any other organisation(s) supported you to work through
                any of the above issues?</label>
              <b-form-textarea id="supported" v-model="selfDeclaration.supported_inforamtion" placeholder=""
                rows="8"></b-form-textarea>
            </div>

            <div class="form__item">
              <label class="form__label" for="goals">d. Please give details of how you completed the sentence
                imposed, (for example did you pay your fine as required, what
                conditions were attached to your probation/community
                service/supervised attendance order, did you comply with the
                requirements of your order/custodial sentence etc)?</label>
              <b-form-textarea id="sentence" v-model="selfDeclaration.completed_the_sentence_imposed" placeholder=""
                rows="8"></b-form-textarea>
            </div>

            <div class="form__item">
              <label class="form__label" for="goals">e. What have you learned from the experience?</label>
              <b-form-textarea id="learned" v-model="selfDeclaration.learned_from_the_experience" placeholder=""
                rows="8"></b-form-textarea>
            </div>
          </div>
        </section>

        <section class="section-form-style">
          <h3>
            Section 2 – Details of any disciplinary action in relation to
            children
          </h3>

          <b-form-group
            label="Have you been disciplined because of inappropriate behaviour towards a child which may have harmed them or put them at risk of harm?">
            <b-form-radio v-model="selfDeclaration.disciplinedSelected" name="disciplined-radios"
              value="Yes">Yes</b-form-radio>
            <b-form-radio v-model="selfDeclaration.disciplinedSelected" name="disciplined-radios"
              value="No">No</b-form-radio>
          </b-form-group>

          <div class="" v-if="selfDeclaration.disciplinedSelected === 'Yes'">
            <div class="form__item">
              <label class="form__label" for="disciplined">Please give details</label>
              <b-form-textarea id="disciplined" v-model="selfDeclaration.disciplinary_action_details" placeholder=""
                rows="8"></b-form-textarea>
            </div>
          </div>
        </section>

        <section class="section-form-style">
          <h3>
            Section 3 – Relevant non-conviction information (including any
            police information)
          </h3>

          <b-form-group label="a. Have you been part of an investigation?">
            <b-form-radio v-model="selfDeclaration.investigationSelected" name="investigation-radios"
              value="Yes">Yes</b-form-radio>
            <b-form-radio v-model="selfDeclaration.investigationSelected" name="investigation-radios"
              value="No">No</b-form-radio>
          </b-form-group>

          <div class="" v-if="selfDeclaration.investigationSelected === 'Yes'">
            <div class="form__item">
              <label class="form__label" for="investigation">Please give details</label>
              <b-form-textarea id="investigation" v-model="selfDeclaration.non_conviction_information" placeholder=""
                rows="8"></b-form-textarea>
            </div>
          </div>

          <b-form-group
            label="b. Are you, or have you ever been, known to any Social Work Department/Social Services Department as an actual or potential risk to children?">
            <b-form-radio v-model="selfDeclaration.socialWorkSelected" name="socialWork-radios"
              value="Yes">Yes</b-form-radio>
            <b-form-radio v-model="selfDeclaration.socialWorkSelected" name="socialWork-radios"
              value="No">No</b-form-radio>
          </b-form-group>

          <div class="" v-if="selfDeclaration.socialWorkSelected === 'Yes'">
            <div class="form__item">
              <label class="form__label" for="socialWork">Please give details</label>
              <b-form-textarea id="socialWork" v-model="selfDeclaration.potential_risk_to_children_details"
                placeholder="" rows="8"></b-form-textarea>
            </div>
          </div>
        </section>

        <section class="section-form-style">
          <h3>
            Section 4 – Protection of Vulnerable Groups (Scotland) Act 2007
          </h3>
          <p>
            Before signing the declaration below, please read the following
            notes on the Protection of Vulnerable Groups (Scotland) Act 2007
            (PVG Act):
          </p>
          <ul>
            <li>
              1. Section 34 of the PVG Act makes it an offence for an individual
              to do, or to seek or agree to do any regulated work (paid or
              unpaid) from which the individual is barred.
            </li>
            <li>
              2. Section 35 of the same act makes it an offence for an
              organisation to offer regulated work (paid or unpaid) to an
              individual barred from that work.
            </li>
          </ul>

          <p>
            3. A person is barred from regulated work with children if they are:
          </p>
          <ul>
            <li>
              • The subject of an automatic listing (under section 14 of the PVG
              Act).
            </li>
            <li>
              • Included in the PVG Children's List (and, by default, the
              Independent Safeguarding Authority Children's List which covers
              the rest of the UK) under section 15 of the PVG Act.
            </li>
          </ul>

          <p>
            4. Under section 12 of the PVG Act an individual can be 'considered
            for listing' as information on their suitability to work with
            children is assessed.
          </p>

          <ul>
            <li>
              *I confirm that I am not barred from regulated work with children
              as set out in sections 14 and 15 of the PVG Act, nor am I under
              'consideration for listing' as set out in section 12 of the same
              Act.
            </li>
            <li>
              I certify that all information contained in this form is true and
              correct to the best of my knowledge and realise that false
              information or omissions may lead to dismissal.
            </li>
            <li>
              I understand that deliberately giving false information can result
              in prosecution.
            </li>
          </ul>

          <p>Section 5 – Declaration</p>
          <ul>
            <li>
              1. I hereby declare and represent that, except for as disclosed
              above, I have not at any time, whether in the United Kingdom or
              abroad, been found guilty and sentenced by a court for a criminal
              offence.
            </li>
            <li>
              2. I will assist the Scottish FA to request a Scheme Record/Scheme
              Record Update (as appropriate under the PVG Act) for the purposes
              of verifying the replies given in this declaration, including
              enquiries of any relevant authority.
            </li>
            <li>
              3. I agree to inform the Scottish FA if I am convicted of an
              offence while a member of staff or volunteer with the
              organisation. I understand that failure to do so may lead to the
              immediate suspension of my work (paid or unpaid) for the
              organisation and/or the termination of my services.
            </li>
            <li>
              4. If I become considered for listing, I understand this will
              result in precautionary suspension.
            </li>
            <li>
              5. I agree to abide by the conditions above and certify that the
              information contained in this form is true and correct to the best
              of my knowledge and I realise that false information or wilful
              omissions may lead to the immediate suspension of my work for the
              organisation or the termination of my services.
            </li>
          </ul>
        </section>

        <div class="form__item">
          <h4>Signature</h4>
          <p v-if="selfDeclarationSignature.signature_change === true">
            Please sign below
          </p>
          <div class="signatureWrapper">
            <vueSignature v-if="selfDeclarationSignature.signature_change === true" ref="selfDeclarationCoachSignature"
              :sigOption="signatureOptions" :w="'800px'" :h="'400px'" :disabled="false"></vueSignature>
            <img v-else :src="getImgUrl(selfDeclarationSignature.signature)" />

            <div v-if="selfDeclarationSignature.signature_change === true" class="player-game-responce">
              <button @click="
                saveSelfDeclarationSignature('selfDeclarationCoachSignature')
                ">
                Save
              </button>
              <button @click="clearSignature('selfDeclarationCoachSignature')">
                Clear
              </button>
            </div>
            <div v-else class="player-game-responce">
              <button @click="changeSignature('coach_signature')">Edit</button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <template v-if="alljobDescriptionSignatures !== null">
      <img alt="" class="visually-hidden" :id="alljobDescriptionSignatures.signature"
        :src="`/images/${alljobDescriptionSignatures.signature}`" />
    </template>

    <template v-if="allCodeOfConductSignatures.length > 0">
      <img v-for="sig in allCodeOfConductSignatures" :key="`${sig.id}-codeOfConductSignatures`" alt=""
        class="visually-hidden" :id="sig.signature" :src="`/images/${sig.signature}`" />
    </template>

    <template v-if="selfDeclarationDocuments.length > 0">
      <img v-for="doc in selfDeclarationDocuments" :key="`${doc.id}-selfDeclarationDocuments`" alt=""
        class="visually-hidden" :id="doc.signiture" :src="`/images/${doc.signiture}`" />
    </template>
    <img alt="" class="visually-hidden" id="png-logo" />
  </div>
</template>
<script>
import { getSeasonWindow } from "@/config/tenant";
import SpinnerLoader from "../../components/LoadingSpinning";
import AppTemplate from "../layouts/App";
import { mapGetters } from "vuex";
import { USER_POPULATE } from "@/store/actions/user.js";
import { Users } from "@/services/user-service.js";
import { Coaches } from "@/services/coaches-service.js";
import { Teams } from "@/services/teams-service.js";
import { Games } from "@/services/games-service.js";
import { Documents } from "@/services/documents-service.js";
import { PerformanceReview } from "@/services/performance-review-service.js";
import vueSignature from "vue-signature";
import extendSeasonEndDateToFullYearMixin from "@/mixin/extendSeasonEndDateToFullYear.js";
import ImageUploader from "../../components/ImageUploader";
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import moment from "moment";
import JsPDF from "jspdf";
import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import TenantLogo from "@/components/TenantLogo/index.vue";
import { avatarUrl } from "@/utils/avatar";

export default {
  name: "Coaches",
  mixins: [extendSeasonEndDateToFullYearMixin],
  components: {
    AppTemplate,
    SpinnerLoader,
    VueDatePicker,
    vueSignature,
    ImageUploader,
    QuillEditor,
    TenantLogo,
  },
  data() {
    return {
      loadingStuff: false,
      gridListView: "grid",
      editMode: false,
      selectedPerformanceTarget: {
        edit: false,
      },
      allCoachesMissingData: [],
      columnsCoachMissingData: [
        { label: "Name", field: "coach_name", sortable: true },
        { label: "Email", field: "coach_email", sortable: true },
        { label: "Phone", field: "coach_phone", sortable: true },
        { label: "PVG Number", field: "PVG_number", sortable: true },
        { label: "Child Wellbeing", field: "child_wellbeing_certificate_completed", sortable: true },
        { label: "Disclosure", field: "disclosure_certificate_number", sortable: true },
        { label: "First Aid", field: "first_aid_completed", sortable: true },
        { label: "First Aid Cert", field: "first_aid_image_url", sortable: true },
        { label: "Coaching Badges", field: "coaching_badges", sortable: true },
        { label: "Missing", field: "missing_count", sortable: true, type: "number" },
      ],
      signatureOptions: {
        penColor: "rgb(0, 0, 0)",
        backgroundColor: "rgb(255,255,255)",
      },
      coachGameTargetsData: [],
      coachesData: [],
      coachesUsersData: [],
      clubTeams: [],
      allTeamsGameResultsData: [],
      selfDeclaration: {
        coach_id: "",
        created_date: "",
        role_details: "",
        offenceSelected: "No",
        details_of_the_offences: "",
        reasons_and_circumstances: "",
        supported_inforamtion: "",
        completed_the_sentence_imposed: "",
        learned_from_the_experience: "",
        disciplinedSelected: "No",
        disciplinary_action_details: "",
        investigationSelected: "No",
        non_conviction_information: "",
        socialWorkSelected: "No",
        potential_risk_to_children_details: "",
        signiture_id: null,
      },
      selfDeclarationSignature: {
        signature: null,
        signature_change: true,
      },
      selectedcoachesQualifications: {
        UEFA_A: 0,
        UEFA_B: 0,
        UEFA_C: 0,
        UEFA_Futsal_B: 0,
        UEFA_Goalkeeper_A: 0,
        UEFA_Goalkeeper_B: 0,
        UEFA_Pro: 0,
        details: "",
        youth_A_Elite: 0,
        youth_B_Elite: 0,
      },
      selectedCoachTab: "coaches-tab",
      selectedTab: "contact-tab",
      userData: {
        name: "",
        userType: "",
      },
      userHeaderData: {
        name: "",
        userType: "",
      },
      selfDeclarationDocuments: [],
      codeOfConductSignature: {
        signature: null,
        signature_change: true,
      },
      uploadedDocuments: [],
      allCodeOfConductSignatures: [],
      alljobDescriptionSignatures: null,
      selectedCPDData: {},
      cpdData: [],
      codeOfConductData: {},
      jobDescriptionData: {},
      newHomeWorkData: {},
      selectedUserDataForHeader: {},
      selectedUserValue: "",
      weekSelectedNumber: "",
      imageFile: null,
      imageToBeRemoved: null,
      imageURL: "",
      image: {
        imageName: "",
        path: "",
        file: null,
      },
      // Modal visibility properties for Vue 3 migration
      showMakeCodPDFModal: false,
      showMakeSelfDeclarationPDFModal: false,
      showPerformanceTargetsModal: false,
      showAddEditCPD: false,
      showAddEditCoach: false,
      showAddHomeworkModal: false,
      showJobDescriptionModal: false,
      showCodeOfConductModal: false,
      showSelfDeclarationModal: false,
    };
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters(["getProfile", "getCoachesUsersData"]),
    coachComplianceRows() {
      return this.allCoachesMissingData.map((coach) => ({
        ...coach,
        coach_name: coach.coach_name || this.getCoachesName(coach.coach_id),
        coaching_badges: this.getCoachingBadges(coach),
        missing_count: this.getMissingCount(coach),
      }));
    },
    coachComplianceSummary() {
      const rows = this.coachComplianceRows;
      if (rows.length === 0) return null;

      let expiringSoon = 0;
      let totalMissing = 0;
      let fullyCompliant = 0;

      rows.forEach((row) => {
        if (row.missing_count === 0) fullyCompliant++;
        totalMissing += row.missing_count;

        const dueDates = [row.PVG_scheme_due_date, row.child_wellbeing_certificate_due_date, row.first_aid_due_date];
        dueDates.forEach((d) => {
          if (this.isExpiringSoon(d)) expiringSoon++;
        });
      });

      return {
        totalCoaches: rows.length,
        fullyCompliant,
        expiringSoon,
        missingItems: totalMissing,
      };
    },
  },
  created() {
    this.loadingStuff = true;
    this.weekSelectedNumber = moment().isoWeek();
    this.setMonToSundayWeekDates();
    this.checkSeasionDates();

    const clientId = JSON.parse(localStorage.getItem("the_w_selectedClientId"));
    this.getUserByIdForHeader(clientId);
    this.getUserById(clientId).then((response) => {
      if (response === true) {
        if (this.userData.userType === "Coach") {
          this.populateCoachesData();
        }

        if (this.userData.userType === "Admin") {
          this.getAllCoaches();
        }
      }
    });
    this.loadingStuff = false;
  },
  methods: {
    // Serve documents via the PHP endpoint (resolves the uploads/documents
    // folder + legacy root). Mirrors documents/index.vue.
    getDocumentUrl(filename) {
      if (!filename) return "";
      if (window.location.href.indexOf("8080") > -1) {
        return `http://www.localhost:8888/serve-document.php?file=${encodeURIComponent(filename)}`;
      }
      return `/personal-training-BE/serve-document.php?file=${encodeURIComponent(filename)}`;
    },
    getCoachesName(id) {
      const coach = this.coachesData.find((coach) => coach.id === id);
      return coach ? coach.name : "";
    },
    getListOfCoachIds() {
      let coachIds = [];
      this.coachesData.filter((coach) => {
        coachIds.push(coach.id);
      });

      return coachIds;
    },
    async getAllCoachesWithMissingData() {
      const listOfCoachIds = this.getListOfCoachIds();

      if (listOfCoachIds.length > 0) {
        const userData = {
          action: "getSelectedCoachesQualificationsById",
          listOfCoachIds: listOfCoachIds,
        };

        try {
          const response = await Coaches.find(userData);
          if (response && response.status === 200) {
            this.allCoachesMissingData = response.data;
          }
        } catch (error) {
          console.error("Failed to load coach compliance data:", error);
        }
      }
    },
    getCoachingBadges(coach) {
      const badges = [];
      if (coach.UEFA_C) badges.push("UEFA C");
      if (coach.UEFA_B) badges.push("UEFA B");
      if (coach.UEFA_A) badges.push("UEFA A");
      if (coach.UEFA_Pro) badges.push("UEFA Pro");
      if (coach.youth_B_Elite) badges.push("Youth B Elite");
      if (coach.youth_A_Elite) badges.push("Youth A Elite");
      if (coach.UEFA_Goalkeeper_B) badges.push("GK B");
      if (coach.UEFA_Goalkeeper_A) badges.push("GK A");
      if (coach.UEFA_Futsal_B) badges.push("Futsal B");
      return badges.length > 0 ? badges.join(", ") : "None";
    },
    getMissingCount(coach) {
      let count = 0;
      if (!coach.PVG_number) count++;
      if (!coach.child_wellbeing_certificate_completed) count++;
      if (!coach.disclosure_certificate_number) count++;
      if (!coach.first_aid_completed) count++;
      if (!coach.first_aid_image_url) count++;
      if (!coach.coach_email) count++;
      if (!coach.coach_phone) count++;
      if (this.isExpired(coach.PVG_scheme_due_date)) count++;
      if (this.isExpired(coach.child_wellbeing_certificate_due_date)) count++;
      if (this.isExpired(coach.first_aid_due_date)) count++;
      return count;
    },
    isExpired(dateStr) {
      if (!dateStr) return false;
      return moment(dateStr).isBefore(moment(), "day");
    },
    isExpiringSoon(dateStr) {
      if (!dateStr) return false;
      const due = moment(dateStr);
      return due.isAfter(moment()) && due.diff(moment(), "days") <= 30;
    },
    getExpiryClass(dateStr) {
      if (this.isExpired(dateStr)) return "red-warning";
      if (this.isExpiringSoon(dateStr)) return "amber-warning";
      return "green-success";
    },
    exportCompliancePDF() {
      const pdf = new JsPDF("l", "mm", "a4");
      const rows = this.coachComplianceRows;
      const pageWidth = 297;
      const margin = 10;

      // Club logo — grab the rendered TenantLogo img from the page
      try {
        const logoEl = document.querySelector("#main-logo");
        if (logoEl) {
          const canvas = document.createElement("canvas");
          canvas.width = 200;
          canvas.height = 200;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(logoEl, 0, 0, 200, 200);
          const logoData = canvas.toDataURL("image/png");
          pdf.addImage(logoData, "PNG", margin, 3, 20, 20);
        }
      } catch (e) {
        // Logo not available — continue without it
      }

      // Title (offset right if logo present)
      const titleX = margin + 24;
      pdf.setFontSize(16).setFont(undefined, "bold");
      pdf.text("Coaches Compliance Report", titleX, 12);
      pdf.setFontSize(10).setFont(undefined, "normal");
      pdf.text("Generated: " + moment().format("MMMM Do YYYY"), titleX, 19);

      // Summary
      const summary = this.coachComplianceSummary;
      pdf.text(
        "Total: " + summary.totalCoaches + " | Fully Compliant: " + summary.fullyCompliant + " | Expiring Soon: " + summary.expiringSoon + " | Missing Items: " + summary.missingItems,
        margin, 29,
      );

      // Table headers
      let yPos = 38;
      const headers = ["Name", "Email", "Phone", "PVG", "Child Wellbeing", "Disclosure", "First Aid", "First Aid Cert", "Badges", "Missing"];
      const colWidths = [35, 40, 28, 22, 30, 25, 25, 22, 40, 15];

      pdf.setFillColor(0, 85, 150);
      pdf.rect(margin, yPos - 5, pageWidth - margin * 2, 8, "F");
      pdf.setTextColor(255, 255, 255);
      pdf.setFontSize(7).setFont(undefined, "bold");

      let xPos = margin;
      headers.forEach((h, i) => {
        pdf.text(h, xPos + 1, yPos);
        xPos += colWidths[i];
      });

      yPos += 6;
      pdf.setTextColor(51, 51, 51);
      pdf.setFontSize(7).setFont(undefined, "normal");

      rows.forEach((row) => {
        if (yPos > 190) {
          pdf.addPage();
          yPos = 15;
        }

        xPos = margin;
        const values = [
          String(row.coach_name || "Unknown"),
          String(row.coach_email || "Missing"),
          String(row.coach_phone || "Missing"),
          String(row.PVG_number || "Missing"),
          String(row.child_wellbeing_certificate_completed || "Missing"),
          String(row.disclosure_certificate_number || "Missing"),
          row.first_aid_completed ? this.formatDateForHuman(row.first_aid_completed) : "No",
          row.first_aid_image_url ? "Yes" : "No",
          String(row.coaching_badges || "None"),
          String(row.missing_count),
        ];

        // Alternate row background
        if (rows.indexOf(row) % 2 === 0) {
          pdf.setFillColor(245, 245, 245);
          pdf.rect(margin, yPos - 4, pageWidth - margin * 2, 6, "F");
        }

        values.forEach((val, i) => {
          const truncated = val.length > (colWidths[i] / 2) ? val.substring(0, Math.floor(colWidths[i] / 2)) + "..." : val;
          pdf.text(truncated, xPos + 1, yPos);
          xPos += colWidths[i];
        });

        yPos += 6;
      });

      pdf.save(`coaches-compliance-${moment().format("YYYY-MM-DD")}.pdf`);
    },
    exportComplianceCSV() {
      const rows = this.coachComplianceRows;
      const headers = [
        "Name", "Email", "Phone", "PVG Number", "PVG Due Date",
        "Child Wellbeing Cert", "Child Wellbeing Due Date",
        "Disclosure Cert", "First Aid Completed", "First Aid Due Date",
        "First Aid Cert Uploaded", "Coaching Badges", "Missing Items Count",
      ];

      const csvRows = [headers.join(",")];

      rows.forEach((row) => {
        const values = [
          row.coach_name || "",
          row.coach_email || "",
          row.coach_phone || "",
          row.PVG_number || "",
          row.PVG_scheme_due_date || "",
          row.child_wellbeing_certificate_completed || "",
          row.child_wellbeing_certificate_due_date || "",
          row.disclosure_certificate_number || "",
          row.first_aid_completed || "",
          row.first_aid_due_date || "",
          row.first_aid_image_url ? "Yes" : "No",
          row.coaching_badges || "",
          row.missing_count,
        ];
        csvRows.push(values.map((v) => `"${String(v).replace(/"/g, '""')}"`).join(","));
      });

      const blob = new Blob([csvRows.join("\n")], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `coaches-compliance-${moment().format("YYYY-MM-DD")}.csv`;
      link.click();
      URL.revokeObjectURL(link.href);
    },
    removeNumberFromStart(documentName) {
      return documentName.substring(documentName.indexOf("_") + 1);
    },
    async getDocumentUploadsByUserId() {
      const userData = {
        action: "getDocumentUploadsByUserId",
        user_id: this.selectedUserValue.id,
      };
      const response = await Documents.find(userData).catch((error) => {
        console.log(error);
      });

      if (response.status === 200) {
        this.uploadedDocuments = response.data;
      }
    },
    gridListSwitch(type) {
      this.gridListView = type;
    },
    newPageCheck(height, dynamicHeight, pdf, type) {
      if (height >= "210") {
        pdf.addPage();
        return 10;
      } else {
        if (type === "cod") {
          return dynamicHeight;
        }

        height =
          typeof dynamicHeight === "number"
            ? Math.round(dynamicHeight + height + 10)
            : Math.round(dynamicHeight.h + height + 10);
        return height;
      }
    },
    produceSelfCodPDF(document) {
      this.showModal("makeCodPDFModal");
      setTimeout(() => {
        let pdf = this.makeCodPDF(document);
        pdf.previewLink.src = pdf.pdfData.output("datauristring");
        this.showReport = true;
      }, 500);
    },
    produceSelfDeclarationPDF(document) {
      this.showModal("makeSelfDeclarationPDFModal");
      setTimeout(() => {
        let pdf = this.makeSelfDeclarationPDF(document);
        pdf.previewLink.src = pdf.pdfData.output("datauristring");
        this.showReport = true;
      }, 500);
    },
    makeCodPDF(codData) {
      let previewContainer = document.getElementById("theCodPDF_preview");

      let pdf = new JsPDF("p", "mm", "a4");
      let img = document.getElementById("png-logo");
      pdf.addImage(img, "PNG", 5, 4, 20, 20);

      pdf.setFontSize(12).setFont(undefined, "bold");
      pdf.text(30, 13, "CODE OF CONDUCT");

      const stripHTMLTags = (str) => str.replace(/<[^>]*>/g, "");

      let textStuff = stripHTMLTags(this.codeOfConductData.text);
      let textLines = textStuff.split(/&nbsp;/g);

      pdf.setFontSize(9).setFont(undefined, "normal");

      let dynamicHeight = 33;

      textLines.map((lines) => {
        let splitLines = pdf.splitTextToSize(lines, 190);
        let linesDimensions = pdf.getTextDimensions(splitLines);

        dynamicHeight = linesDimensions.h + dynamicHeight + 10;
        pdf.text(5, dynamicHeight, lines, { maxWidth: 190 });
        dynamicHeight = dynamicHeight + 10;
        dynamicHeight = this.newPageCheck(
          dynamicHeight,
          dynamicHeight,
          pdf,
          "cod",
        );
      });

      let signitureImage = document.getElementById(codData.signature);
      pdf.addImage(signitureImage, "JPEG", 5, dynamicHeight + 20, 150, 80);
      pdf.text(
        5,
        dynamicHeight + 25,
        this.formatDateForHuman(codData.created_date),
      );

      return { pdfData: pdf, previewLink: previewContainer };
    },
    makeSelfDeclarationPDF(selfDeclarationData) {
      let previewContainer = document.getElementById(
        "theSelfDeclarationPDF_preview",
      );
      let pdf = new JsPDF("p", "mm", "a4");
      let img = document.getElementById("png-logo");
      pdf.addImage(img, "PNG", 5, 4, 20, 20);

      pdf.setFontSize(16).setFont(undefined, "bold");
      pdf.text(
        30,
        13,
        "Self-declaration Form For Regulated Work With Children",
      );

      pdf.setFontSize(9).setFont(undefined, "normal");
      pdf.text(
        5,
        40,
        `The Scottish FA / ${this.setClubName()} require that anyone applying to do regulated work with children, must complete a self-declaration form as part of the recruitment process.`,
        { maxWidth: 190 },
      );
      pdf.text(
        5,
        55,
        "Regulated work with children posts are exempt from the Rehabilitation of Offenders Act 1974 by the  Exclusions and Exceptions Scotland Order 2010. Candidates are therefore required to disclose all convictions  (spent and unspent), cautions, and any relevant non-conviction information.",
        { maxWidth: 190 },
      );
      pdf.text(
        5,
        70,
        `Please note that any information you give in this form will be managed according to the Scottish FA / ${this.setClubName()} Data Protection Policy. Having a criminal record will not necessarily bar you from working  with us. This will depend on the circumstances and background of any offences and the nature of the position.`,
        { maxWidth: 190 },
      );

      pdf.text(5, 85, "Completing the form:");
      pdf.text(
        5,
        90,
        "1. Please give details regarding any convictions and cautions under the heading in Section 1.",
      );
      pdf.text(
        5,
        95,
        "2. Please provide details of any disciplinary action in Section 2.",
      );
      pdf.text(
        5,
        100,
        "3. Please give details of any relevant non-conviction information in Section 3.",
      );
      pdf.text(
        5,
        105,
        "4. If you have no convictions, cautions, or relevant non-conviction information please go to Section 4 and sign the declaration in Section 5.",
      );
      pdf.text(
        5,
        110,
        "5. Return the form in a sealed envelope marked 'Private and Confidential – Self Declaration'. Please  do not put your completed application/registration form in the same envelope. It is important that  the forms are kept separate. Your completed self-declaration form will only be seen by individual in the organisation who have a responsibility for recruiting staff and volunteers.",
        { maxWidth: 190 },
      );

      pdf.setFontSize(9).setFont(undefined, "bold");
      pdf.text(5, 135, "PERSONAL DETAILS");

      pdf.setFontSize(9).setFont(undefined, "normal");
      pdf.text(5, 140, `Full Name: ${this.selectedUserValue.name}`);
      pdf.text(5, 145, `Tel number: ${this.selectedUserValue.phone}`);
      pdf.text(5, 150, `Email: ${this.selectedUserValue.email}`);
      pdf.text(5, 155, `Address: ${this.selectedUserValue.address}`);
      pdf.text(5, 160, `Post Code: ${this.selectedUserValue.post_code}`);

      // Role details ---------------------------------------------------------------- //

      pdf.setFontSize(9).setFont(undefined, "bold");
      pdf.text(5, 175, `ROLE DETAILS`);
      pdf.setFontSize(9).setFont(undefined, "normal");

      let paraOne = selfDeclarationData.role_details;
      let paraOneLines = pdf.splitTextToSize(paraOne, 190);
      pdf.text(5, 180, paraOneLines);

      let dynamicHeight = pdf.getTextDimensions(paraOneLines);

      // section 1 Convictions and Cautions ---------------------------------------------------------------- //

      dynamicHeight = dynamicHeight.h + 180;

      dynamicHeight = this.newPageCheck(
        dynamicHeight + dynamicHeight,
        dynamicHeight + dynamicHeight,
        pdf,
      );

      dynamicHeight = dynamicHeight + 10;
      pdf.setFontSize(9).setFont(undefined, "bold");
      pdf.text(5, dynamicHeight + 190, "Section 1 – Convictions and Cautions");
      pdf.setFontSize(9).setFont(undefined, "normal");

      dynamicHeight = dynamicHeight + 195;
      if (selfDeclarationData.offenceSelected === 0) {
        pdf.text(5, dynamicHeight, "No Convictions and Cautions");
      } else {
        // a ---------------------------------------------------------------- //

        pdf.text(
          5,
          dynamicHeight,
          "a) Please give the date and details of the offence(s) with which you were charged, the sentence that you received and the court where your case(s) was heard.",
          { maxWidth: 190 },
        );

        let heightOne = dynamicHeight + 10;
        let paraTwo = selfDeclarationData.details_of_the_offences;
        let paraTwoLines = pdf.splitTextToSize(paraTwo, 190);
        let dynamicHeightTwo = pdf.getTextDimensions(paraTwoLines);

        pdf.text(
          5,
          dynamicHeight + 10,
          selfDeclarationData.details_of_the_offences,
          { maxWidth: 190 },
        );

        dynamicHeight = this.newPageCheck(
          dynamicHeightTwo + heightOne,
          dynamicHeightTwo + heightOne,
          pdf,
        );

        // b ---------------------------------------------------------------- //

        pdf.setFontSize(9).setFont(undefined, "bold");
        pdf.text(
          5,
          dynamicHeight,
          "b) Please give details of the reasons and circumstances that led to your offence(s).",
        );
        pdf.setFontSize(9).setFont(undefined, "normal");

        selfDeclarationData.reasons_and_circumstances =
          "ontrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham. ontrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham. ontrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham. ontrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham. ontrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham. ontrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.";

        let heightTwo = dynamicHeight + 10;
        let paraThree = selfDeclarationData.reasons_and_circumstances;
        let paraThreeLines = pdf.splitTextToSize(paraThree, 190);
        let dynamicHeightThree = pdf.getTextDimensions(paraThreeLines);
        pdf.text(
          5,
          dynamicHeight + 10,
          selfDeclarationData.reasons_and_circumstances,
          { maxWidth: 190 },
        );

        dynamicHeight = this.newPageCheck(
          dynamicHeightThree + heightTwo,
          dynamicHeightTwo + heightTwo,
          pdf,
        );

        // c ---------------------------------------------------------------- //

        pdf.setFontSize(9).setFont(undefined, "bold");
        pdf.text(
          5,
          dynamicHeight,
          "c) Has any other organisation(s) supported you to work through any of the above issues?",
        );
        pdf.setFontSize(9).setFont(undefined, "normal");

        selfDeclarationData.supported_inforamtion =
          "ontrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham. ontrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham. ontrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham. ontrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham. ontrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham. ontrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.";

        let heightThree = dynamicHeight + 10;
        let paraFour = selfDeclarationData.supported_inforamtion;
        let paraFourLines = pdf.splitTextToSize(paraFour, 190);
        let dynamicHeightFour = pdf.getTextDimensions(paraFourLines);
        pdf.text(
          5,
          dynamicHeight + 10,
          selfDeclarationData.supported_inforamtion,
          { maxWidth: 190 },
        );

        dynamicHeight = this.newPageCheck(
          dynamicHeightFour + heightThree,
          dynamicHeightFour + heightThree,
          pdf,
        );

        // d ---------------------------------------------------------------- //

        pdf.setFontSize(9).setFont(undefined, "bold");
        pdf.text(
          5,
          dynamicHeight + 10,
          "d) Please give details of how you completed the sentence imposed, (for example did you pay your fine  as required, what conditions were attached to your probation/community service/supervised  attendance order, did you comply with the requirements of your order/custodial sentence etc)?",
          { maxWidth: 190 },
        );
        pdf.setFontSize(9).setFont(undefined, "normal");

        let heightFour = dynamicHeight + 25;
        let paraFive = selfDeclarationData.completed_the_sentence_imposed;
        let paraFiveLines = pdf.splitTextToSize(paraFive, 190);
        let dynamicHeightFive = pdf.getTextDimensions(paraFiveLines);
        pdf.text(
          5,
          dynamicHeight + 25,
          selfDeclarationData.supported_inforamtion,
          { maxWidth: 190 },
        );

        dynamicHeight = this.newPageCheck(
          dynamicHeightFive + heightFour,
          dynamicHeightFive + heightFour,
          pdf,
        );

        // e ---------------------------------------------------------------- //

        pdf.setFontSize(9).setFont(undefined, "bold");
        pdf.text(
          5,
          dynamicHeight + 10,
          "What have you learned from the experience?",
          { maxWidth: 190 },
        );
        pdf.setFontSize(9).setFont(undefined, "normal");

        let heightFourE = dynamicHeight + 25;
        let paraFiveE = selfDeclarationData.completed_the_sentence_imposed;
        let paraFiveLinesE = pdf.splitTextToSize(paraFiveE, 190);
        let dynamicHeightFiveE = pdf.getTextDimensions(paraFiveLinesE);
        pdf.text(
          5,
          dynamicHeight + 25,
          selfDeclarationData.supported_inforamtion,
          { maxWidth: 190 },
        );

        dynamicHeight = this.newPageCheck(
          dynamicHeightFiveE + heightFourE,
          dynamicHeightFiveE + heightFourE,
          pdf,
        );
      }

      // section 2  ---------------------------------------------------------------- //

      pdf.setFontSize(9).setFont(undefined, "bold");
      pdf.text(
        5,
        dynamicHeight + 10,
        "Section 2 – Details of any disciplinary action in relation to children",
      );
      pdf.setFontSize(9).setFont(undefined, "normal");

      //selfDeclarationData.disciplinedSelected = 1;

      if (selfDeclarationData.disciplinedSelected === 0) {
        pdf.text(
          5,
          dynamicHeight + 15,
          "No disciplinary action in relation to children",
        );
      } else {
        //  details  ---------------------------------------------------------------- //

        pdf.setFontSize(9).setFont(undefined, "bold");
        pdf.text(
          5,
          dynamicHeight + 20,
          "Have you been disciplined because of inappropriate behaviour towards a child which may have harmed them or put them at risk of harm?, please give details.",
          { maxWidth: 190 },
        );
        pdf.setFontSize(9).setFont(undefined, "normal");

        let heightFive = dynamicHeight + 35;
        let paraSix = selfDeclarationData.disciplinary_action_details;
        let paraSixLines = pdf.splitTextToSize(paraSix, 190);
        let dynamicHeightSix = pdf.getTextDimensions(paraSixLines);
        pdf.text(
          5,
          dynamicHeight + 35,
          selfDeclarationData.disciplinary_action_details,
          { maxWidth: 190 },
        );

        dynamicHeight = this.newPageCheck(
          dynamicHeightSix + heightFive,
          dynamicHeightSix + heightFive,
          pdf,
        );
      }

      // section 3  ---------------------------------------------------------------- //

      pdf.setFontSize(9).setFont(undefined, "bold");
      pdf.text(
        5,
        dynamicHeight + 25,
        "Section 3 – Relevant non-conviction information (including any police information)",
      );
      pdf.setFontSize(9).setFont(undefined, "normal");

      //selfDeclarationData.offenceSelected = 1;

      if (selfDeclarationData.offenceSelected === 0) {
        pdf.text(5, dynamicHeight + 30, "a) No non-conviction information");
      } else {
        // 3 a ---------------------------------------------------------------- //

        pdf.setFontSize(9).setFont(undefined, "bold");
        pdf.text(
          5,
          dynamicHeight + 30,
          "a) Please provide details of investigations, reasons and circumstances that led to your investigation(s)  and disposal if known. ",
          { maxWidth: 190 },
        );
        pdf.setFontSize(9).setFont(undefined, "normal");

        selfDeclarationData.non_conviction_information =
          "ontrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham. ontrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham. ontrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham. ontrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham. ontrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham. ontrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.";

        let heightSix = dynamicHeight + 40;
        let paraSix = selfDeclarationData.non_conviction_information;
        let paraSixLines = pdf.splitTextToSize(paraSix, 190);
        let dynamicHeightSixA = pdf.getTextDimensions(paraSixLines);
        pdf.text(
          5,
          dynamicHeight + 40,
          selfDeclarationData.non_conviction_information,
          { maxWidth: 190 },
        );

        dynamicHeight = this.newPageCheck(
          dynamicHeightSixA + heightSix,
          dynamicHeightSixA + heightSix,
          pdf,
        );
      }

      if (selfDeclarationData.socialWorkSelected === 0) {
        pdf.text(5, dynamicHeight + 35, "b) No Social Work information");
        dynamicHeight = this.newPageCheck(
          dynamicHeight + 35,
          dynamicHeight + 35,
          pdf,
        );
      } else {
        // 3 b ---------------------------------------------------------------- //

        pdf.setFontSize(9).setFont(undefined, "bold");
        pdf.text(
          5,
          dynamicHeight + 10,
          "b) Are you, or have you ever been, known to any Social Work Department/Social Services Department as an actual or potential risk to children?",
          { maxWidth: 190 },
        );
        pdf.setFontSize(9).setFont(undefined, "normal");

        selfDeclarationData.potential_risk_to_children_details =
          "ontrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham. ontrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham. ontrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham. ontrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham. ontrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham. ontrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.";

        let heightSixB = dynamicHeight + 35;
        let paraSix = selfDeclarationData.potential_risk_to_children_details;
        let paraSixLines = pdf.splitTextToSize(paraSix, 190);
        let dynamicHeightSixB = pdf.getTextDimensions(paraSixLines);
        pdf.text(
          5,
          dynamicHeight + 35,
          selfDeclarationData.potential_risk_to_children_details,
          { maxWidth: 190 },
        );

        dynamicHeight = this.newPageCheck(
          dynamicHeightSixB + heightSixB,
          dynamicHeightSixB + heightSixB,
          pdf,
        );
      }

      pdf.setFontSize(9).setFont(undefined, "bold");
      pdf.text(
        5,
        dynamicHeight + 10,
        "Section 4 – Protection of Vulnerable Groups (Scotland) Act 2007",
      );
      pdf.setFontSize(9).setFont(undefined, "normal");
      pdf.text(
        5,
        dynamicHeight + 15,
        "Before signing the declaration below, please read the following notes on the Protection of Vulnerable Groups  (Scotland) Act 2007 (PVG Act):",
        { maxWidth: 190 },
      );

      pdf.text(
        5,
        dynamicHeight + 25,
        "1. Section 34 of the PVG Act makes it an offence for an individual to do, or to seek or agree to do any  regulated work (paid or unpaid) from which the individual is barred.",
        { maxWidth: 190 },
      );
      pdf.text(
        5,
        dynamicHeight + 33,
        "2. Section 35 of the same act makes it an offence for an organisation to offer regulated work (paid or  unpaid) to an individual barred from that work.",
        { maxWidth: 190 },
      );
      pdf.text(
        5,
        dynamicHeight + 48,
        "3. A person is barred from regulated work with children if they are:",
      );
      pdf.text(
        5,
        dynamicHeight + 53,
        "• The subject of an automatic listing (under section 14 of the PVG Act",
      );
      pdf.text(
        5,
        dynamicHeight + 58,
        "• Included in the PVG Children's List (and, by default, the Independent Safeguarding Authority  Children's List which covers the rest of the UK) under section 15 of the PVG Act.",
        { maxWidth: 190 },
      );

      pdf.text(
        5,
        dynamicHeight + 72,
        "4. Under section 12 of the PVG Act an individual can be 'considered for listing' as information on their  suitability to work with children is assessed.",
        { maxWidth: 190 },
      );
      pdf.text(
        5,
        dynamicHeight + 80,
        "* I confirm that I am not barred from regulated work with children as set out in sections 14 and 15 of the PVG  Act, nor am I under 'consideration for listing' as set out in section 12 of the same Act.",
        { maxWidth: 190 },
      );
      pdf.text(
        5,
        dynamicHeight + 88,
        "I certify that all information contained in this form is true and correct to the best of my knowledge and realise  that false information or omissions may lead to dismissal. I understand that deliberately giving false information can result in prosecution.",
        { maxWidth: 190 },
      );

      pdf.setFontSize(9).setFont(undefined, "bold");
      pdf.text(5, dynamicHeight + 106, "Section 5 – Declaration");
      pdf.setFontSize(9).setFont(undefined, "normal");

      pdf.text(
        5,
        dynamicHeight + 114,
        "1. I hereby declare and represent that, except for as disclosed above, I have not at any time, whether in the  United Kingdom or abroad, been found guilty and sentenced by a court for a criminal offence.",
        { maxWidth: 190 },
      );
      pdf.text(
        5,
        dynamicHeight + 122,
        "2. I will assist the Scottish FA to request a Scheme Record/Scheme Record Update (as appropriate under  the PVG Act) for the purposes of verifying the replies given in this declaration, including enquiries of any  relevant authority.",
        { maxWidth: 190 },
      );
      pdf.text(
        5,
        dynamicHeight + 132,
        "3. I agree to inform the Scottish FA if I am convicted of an offence while a member of staff or volunteer with  the organisation. I understand that failure to do so may lead to the immediate suspension of my work  (paid or unpaid) for the organisation and/or the termination of my services.",
        { maxWidth: 190 },
      );
      pdf.text(
        5,
        dynamicHeight + 145,
        "4. If I become considered for listing, I understand this will result in precautionary suspension.",
      );
      pdf.text(
        5,
        dynamicHeight + 150,
        "5. I agree to abide by the conditions above and certify that the information contained in this form is true and  correct to the best of my knowledge and I realise that false information or wilful omissions may lead to  the immediate suspension of my work for the organisation or the termination of my services.",
        { maxWidth: 190 },
      );

      let signitureImage = document.getElementById(
        selfDeclarationData.signiture,
      );
      pdf.addImage(signitureImage, "JPEG", 5, dynamicHeight + 180, 150, 80);
      pdf.text(
        5,
        dynamicHeight + 185,
        this.formatDateForHuman(selfDeclarationData.created_date),
      );

      return { pdfData: pdf, previewLink: previewContainer };
    },
    async removeUploadedDocument(id, name) {
      const userData = {
        action: "removeDocumentUpload",
        id: id,
        name: name,
      };
      const response = await Documents.find(userData).catch((error) => {
        console.log(error);
      });

      if (response.status === 200) {
        this.getDocumentUploadsByUserId();
        //this.$bvModal.hide("documentEditModal");

        this.$toast.info("Document successfully deleted.", {
          title: "Deleted",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      }
    },
    setClubName() {
      if (this.userData.clubId === "surfSoccer-2085XH") {
        return "The big test";
      }

      if (this.userData.clubId === "dfc-2085XH") {
        return "Dundee";
      }

      if (this.userData.clubId === "dfc-2085XH") {
        return "Dundee";
      }

      if (this.userData.clubId === "hafc-2085XH") {
        return "Hamilton Academical";
      }

      if (this.userData.clubId === "kfc-2085XH") {
        return "kilmarnock fc";
      }
    },
    selfDeclarationModal() {
      this.showModal("selfDeclarationModal");
    },
    getCPDTotalHours() {
      return this.cpdData.length > 0 ? this.cpdData[0].total_hours : 15;
    },
    addEditCPDhModel(edit, item) {
      if (edit === "edit") {
        this.editMode = true;
        this.selectedCPDData = item;
      }
      this.showModal("addEditCPD");
    },
    async getCPDinformationforCoach() {
      const userData = {
        coach_id: this.selectedUserValue.id,
        action: "getCPDinformationforCoach",
      };

      const responce = await Coaches.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.status === 200) {
        this.cpdData = responce.data;
      }
    },
    async saveCPDinformation() {
      this.selectedCPDData.date = moment(this.selectedCPDData.date).format(
        "YYYY-MM-DD",
      );
      const userData = {
        ...this.selectedCPDData,
        coach_id: this.selectedUserValue.id,
        action: "saveCPDinformation",
      };

      const responce = await Coaches.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.status === 200) {
        this.getCPDinformationforCoach();
        this.showAddEditCPD = false;
        this.$toast.info("CPD information saved.", {
          title: "saved",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });

        this.selectedCPDData = {};
      }
    },
    async editCPDinformation() {
      const userData = {
        ...this.selectedCPDData,
        action: "editCPDinformation",
      };

      const responce = await Coaches.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.status === 200) {
        this.getCPDinformationforCoach();
        this.showAddEditCPD = false;
        this.$toast.info("CPD information updated.", {
          title: "updated",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });

        this.selectedCPDData = {};
        this.editMode = false;
      }
    },
    async getSelfDeclarationDocumentsCall() {
      const userData = {
        action: "getSelfDeclarationDocumentsCall",
        coach_id: this.selectedUserValue.id,
      };

      const responce = await Documents.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.status === 200) {
        this.selfDeclarationDocuments = responce.data;
      }
    },
    async saveSelfDeclarationSignatureCall(image, signatureName) {
      this.selfDeclaration.coach_id = this.selectedUserValue.id;
      this.selfDeclaration.created_date = moment().format("YYYY-MM-DD");
      const userData = {
        ...this.selfDeclaration,
        fileName: signatureName,
        imageFile: image,
        action: "saveSelfDeclarationSignatureCall",
      };

      const responce = await Documents.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.status === 200) {
        //this.getCodeOfConductData();
        //this.getCodeOfConductSignatures();
        this.getSelfDeclarationDocumentsCall();
        this.showSelfDeclarationModal = false;
        this.$toast.info("Signature saved.", {
          title: "saved",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      }
    },
    async savejobDescriptionSignatureCall(image, signatureName) {
      const userData = {
        fileName: signatureName,
        imageFile: image,
        coach_id: this.selectedUserValue.id,
        action: "savejobDescriptionSignatureCall",
        created_date: moment().format("YYYY-MM-DD"),
      };

      const responce = await Documents.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.status === 200) {
        this.getJobDescriptionData();
        this.getJobDescriptionSignatures();
        this.showJobDescriptionModal = false;
        this.$toast.info("Signature saved.", {
          title: "saved",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      }
    },
    async saveCodeOfConductSignatureCall(image, signatureName) {
      const userData = {
        fileName: signatureName,
        imageFile: image,
        coach_id: this.selectedUserValue.id,
        action: "saveCodeOfConductSignatureCall",
        created_date: moment().format("YYYY-MM-DD"),
      };

      const responce = await Documents.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.status === 200) {
        this.getCodeOfConductData();
        this.getCodeOfConductSignatures();
        this.showCodeOfConductModal = false;
        this.$toast.info("Signature saved.", {
          title: "saved",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      }
    },
    async getJobDescriptionData() {
      const userData = {
        action: "getJobDescription",
        job_type: this.selectedUserValue.position,
      };

      const response = await Documents.find(userData).catch((error) => {
        console.log(error);
      });

      if (response.status === 200 && response.data.success !== false) {
        this.jobDescriptionData = response.data.data;
      } else {
        this.jobDescriptionData.text = response.data.message;
      }
    },
    async getCodeOfConductSignatures() {
      const userData = {
        coach_id: this.selectedUserValue.id,
        action: "getCodeOfConductSignatures",
      };

      const responce = await Documents.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.status === 200 && typeof responce.data !== "boolean") {
        this.allCodeOfConductSignatures = responce.data;
      }
    },
    async getJobDescriptionSignatures() {
      const userData = {
        coach_id: this.selectedUserValue.id,
        action: "getjobDescriptionSignatures",
      };

      const responce = await Documents.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.status === 200 && typeof responce.data !== "boolean") {
        this.alljobDescriptionSignatures = responce.data;
      }
    },
    saveSelfDeclarationSignature(signatureName) {
      var _this = this;
      var jpeg = _this.$refs[signatureName].save("image/jpeg");
      this.saveSelfDeclarationSignatureCall(jpeg, signatureName);
    },
    saveSignature(signatureName) {
      var _this = this;
      var jpeg = _this.$refs[signatureName].save("image/jpeg");

      if (signatureName === "jobDescriptionSignature") {
        this.savejobDescriptionSignatureCall(jpeg, signatureName);
      }

      if (signatureName === "coachCOCSignature") {
        this.saveCodeOfConductSignatureCall(jpeg, signatureName);
      }
    },
    async getCodeOfConductData() {
      const userData = {
        action: "getCodeOfConductData",
        clubId: this.selectedUserValue.clubId,
      };
      const response = await Documents.find(userData).catch((error) => {
        console.log(error);
      });

      if (response.status === 200) {
        this.codeOfConductData = response.data;
      }
    },
    jobDescriptionModal() {
      this.showModal("jobDescriptionModal");
    },
    codeOfConductModal() {
      this.showModal("codeOfConductModal");
    },
    checkSeasionDates() {
      if (localStorage.getItem("currentPlayingseasonStartDate") === null) {
        // Tenant-aware fallback window (UK cross-year vs AU calendar year).
        const season = getSeasonWindow();
        localStorage.setItem("currentPlayingseasonStartDate", season.startDate);
        localStorage.setItem("currentPlayingseasonEndDate", season.endDate);
        localStorage.setItem(
          "currentPlayingSeason",
          season.startDate.slice(0, 4),
        );
      }
    },
    checkIntTargetValue(value) {
      if (value !== undefined && value != 0) {
        return 1;
      } else {
        return 0;
      }
    },
    makeTheNewPerformanceReportTargetObject() {
      this.selectedPerformanceTarget.complete = this.checkIntTargetValue(
        this.selectedPerformanceTarget.complete,
      );

      return {
        player_id: this.selectedUserValue.id,
        performance_report_id: 0,
        idp_id: 0,
        target: this.selectedPerformanceTarget.target,
        complete: this.selectedPerformanceTarget.complete,
        category: "",
        created_date: moment().format("YYYY-MM-DD"),
        possession: "",
        action: "addNewPerformanceReportTarget",
      };
    },
    async getCoachTargetsById() {
      const userData = {
        userId: this.selectedUserValue.id,
        action: "getCoachTargetsById",
        season_start_date: localStorage.getItem(
          "currentPlayingseasonStartDate",
        ),
        season_end_date: this.extendSeasonEndDateToFullYear(),
      };
      const responce = await PerformanceReview.find(userData).catch((error) => {
        console.log(error);
      });

      this.coachGameTargetsData = responce.data;
    },
    async deletePerformanceReportTarget() {
      const userData = {
        id: this.selectedPerformanceTarget.id,
        action: "deletePerformanceReportTarget",
      };

      const responce = await PerformanceReview.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.data === "Performance report target deleted") {
        this.getCoachTargetsById();
        this.showPerformanceTargetsModal = false;
        this.$toast.info("Performance report target deleted", {
          title: "Updated",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      }
    },
    async updatePerformanceReportTarget() {
      const userData = {
        ...this.selectedPerformanceTarget,
        action: "updatePerformanceReportTarget",
      };
      const responce = await PerformanceReview.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.data === "Performance report target updated") {
        this.getCoachTargetsById();
        this.showPerformanceTargetsModal = false;
        this.$toast.info("Performance report target updated", {
          title: "Updated",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      }
    },
    async addNewPerformanceReportTarget() {
      const userData = this.makeTheNewPerformanceReportTargetObject();

      const responce = await PerformanceReview.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.data === "Performance report target added") {
        this.getCoachTargetsById();
        this.showPerformanceTargetsModal = false;
        this.$toast.info("Performance report target added", {
          title: "added",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      }
    },
    performanceTargetsModal(data, modelName, typeOfTarget) {
      if (Object.keys(data).length > 0) {
        this.selectedPerformanceTarget = data;
        this.selectedPerformanceTarget.edit = true;
      } else {
        this.selectedPerformanceTarget.edit = false;
      }
      this.selectedPerformanceTarget.typeOfTarget = typeOfTarget;
      // Vue 3 migration: use boolean property instead of $bvModal.show
      this.showPerformanceTargetsModal = true;
    },
    editPlayerProfileInSettings() {
      this.$router.push("/settings").catch(() => { });
    },
    setSelectedTeam(team) {
      this.$router.push({
        name: "teams",
        query: { teamData: JSON.stringify(team) },
      });
    },
    checkGameResult(game) {
      if (Number(game.home_team_goals) > Number(game.away_team_goals)) {
        return "W";
      }
      if (Number(game.home_team_goals) === Number(game.away_team_goals)) {
        return "D";
      }
      if (Number(game.home_team_goals) < Number(game.away_team_goals)) {
        return "L";
      }
    },
    async getCoachesQualificationsById() {
      const userData = {
        coach_id: this.selectedUserValue.id,
        clubId: this.selectedUserValue.clubId,
        action: "getCoachesQualificationsById",
      };

      const responce = await Coaches.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.data !== null) {
        this.selectedcoachesQualifications = responce.data;

        if (typeof responce.data === "string") {
          //this.getCoachesQualificationsById();
        }
      }
    },
    async getTeamsDataById() {
      const userData = {
        coach_id: this.selectedUserValue.id,
        action: "getTeamsByCoachid",
      };
      const responce = await Teams.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.data !== null) {
        Array.isArray(responce.data)
          ? (this.clubTeams = responce.data)
          : (this.clubTeams = [responce.data]);
      }

      const allTeamsIds = this.getAllTeamsIdsFromTeamsEvents();
      // Scope past results to the active season window — the current season,
      // or a past season when one is selected in the header. Previously the
      // current-season case used a rolling "last 3 months → today" window,
      // which bled last season's tail into the view during the off-season.
      this.getAllTeamsPastResults(
        localStorage.getItem("currentPlayingseasonStartDate"),
        localStorage.getItem("currentPlayingseasonEndDate"),
        allTeamsIds,
      );
    },
    tabChange(tabValue, selectedTabValue) {
      this[tabValue] = selectedTabValue;

      if (this[tabValue] === "targets-tab") {
        this.getCoachTargetsById();
      }

      if (this[tabValue] === "documents-tab") {
        this.getCodeOfConductData();
        this.getCodeOfConductSignatures();
        this.getJobDescriptionSignatures();
        this.getJobDescriptionData();
      }
    },
    getImgUrl(pic) {
      // Empty stays empty (callers rely on rendering nothing); a stored
      // "default-image.png" resolves to the neutral avatar via avatarUrl.
      return pic !== undefined && pic !== "" ? avatarUrl(pic) : "";
    },
    clearImageDataFromUpload() {
      ((this.imageURL = ""),
        (this.image = {
          imageName: "",
          path: "",
          file: null,
        }));
    },
    imageUploadObjectDataChanged(data) {
      this.image = data;
    },
    imageUploadFileDataChnged(data) {
      this.imageFile = data;
    },
    selectedUseChanged(coach) {
      this.selectedUserValue = coach;
      this.getTeamsDataById();
      this.getCoachesQualificationsById();
      this.getCPDinformationforCoach();
      this.getSelfDeclarationDocumentsCall();
      this.getDocumentUploadsByUserId();
      let mainLogoSRC = document.getElementById("main-logo").src;
      this.base64SvgToBase64Png(mainLogoSRC, 200).then((pngSrc) => {
        document.getElementById("png-logo").src = pngSrc;
      });
    },
    base64SvgToBase64Png(originalBase64, width) {
      return new Promise((resolve) => {
        let img = document.createElement("img");
        img.onload = function () {
          document.body.appendChild(img);
          let canvas = document.createElement("canvas");
          let ratio = img.clientWidth / img.clientHeight || 1;
          document.body.removeChild(img);
          canvas.width = width;
          canvas.height = width / ratio;
          let ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          try {
            let data = canvas.toDataURL("image/png");
            resolve(data);
          } catch (e) {
            resolve(null);
          }
        };
        img.onerror = function () {
          resolve(null);
        };
        img.src = originalBase64;
      });
    },
    weekSelectedChanged(number) {
      this.weekSelectedNumber = number.weekSelectedNumber;
    },
    mondaySunDatesChanged(data) {
      this.selectedWeekMonSunday = data.monToFri;
    },
    setMonToSundayWeekDates() {
      const year = JSON.stringify(moment().year());
      const monday = moment()
        .year(year)
        .isoWeek(this.weekSelectedNumber)
        .day("monday")
        .startOf("day");
      this.selectedWeekMonSunday =
        monday.format("MMM D - ") + monday.add(6, "days").format("D YYYY");
      // this.depatchMonToSundayWeekDatesInLocalStorage();
    },
    async getUserById(clientId) {
      const userData = {
        clientId: clientId,
        action: "getUserByID",
      };
      const responce = await Users.find(userData).catch((error) => {
        console.log(error);
      });
      if (responce.data.length > 0) {
        this.userData = responce.data[0];
        const userData = responce.data[0];
        this.$store.dispatch(USER_POPULATE, { userData });
        return true;
      }
    },
    async getUserByIdForHeader(clientId) {
      const userData = {
        clientId: clientId,
        action: "getUserByID",
      };
      const responce = await Users.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.data.length > 0) {
        this.userHeaderData = responce.data[0];
      }
    },
    populateCoachesData() {
      const data = [
        {
          clubId: this.userData.clubId,
          coach_id: 0,
          email: this.userData.email,
          id: this.userData.id,
          joined_date: this.userData.joined_date,
          name: this.userData.name,
          phone: this.userData.phone,
          teamId: 0,
          userImage: this.userData.userImage,
          userType: this.userData.userType,
          address: this.userData.address,
          post_code: this.userData.post_code,
          position: this.userData.position,
        },
      ];

      this.coachesData = data;
    },
    async getAllCoaches() {
      const userData = {
        action: "getAllCoachesByClubId",
        clubId: this.userData.clubId,
      };

      const responce = await Coaches.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.data.length > 0) {
        this.coachesData = responce.data;
        this.getAllCoachesWithMissingData();
      }
    },
    convertCoachQualificationsDates() {
      const dateFields = [
        "PVG_scheme_issue_date",
        "PVG_scheme_due_date",
        "child_wellbeing_certificate_completed",
        "child_wellbeing_certificate_due_date",
        "first_aid_completed",
        "first_aid_due_date",
      ];

      dateFields.forEach((field) => {
        const dateValue = this.selectedcoachesQualifications[field];
        if (dateValue !== null && dateValue !== undefined) {
          this.selectedcoachesQualifications[field] =
            this.formatMatchDate(dateValue);
        }
      });
    },
    async addCoachQualificationsSubmit() {
      this.convertCoachQualificationsDates();
      const userData = {
        ...this.selectedcoachesQualifications,
        coach_id: this.selectedUserValue.id,
        clubId: this.selectedUserValue.clubId,
        action: "addCoachQualifications",
      };
      const responce = await Coaches.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.status === 200) {
        this.getCoachesQualificationsById();
        this.loadingStuff = false;
        this.showAddEditCoach = false;
        this.$toast.info("Qualifications added.", {
          title: "Added",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      }
    },
    async editCoachQualificationsSubmit() {
      this.convertCoachQualificationsDates();

      let fileName = null;
      let imageFile = null;

      if (this.image.imageFile !== null && this.imageFile !== null) {
        fileName = this.imageFile.imageName;
        imageFile = this.image;
      }

      const userData = {
        ...this.selectedcoachesQualifications,
        coach_id: this.selectedUserValue.id,
        clubId: this.selectedUserValue.clubId,
        fileName: fileName,
        imageFile: imageFile,
        action: "editCoachesQualifications",
      };

      const responce = await Coaches.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.status === 200) {
        this.getCoachesQualificationsById();
        this.loadingStuff = false;
        this.showAddEditCoach = false;
        this.$toast.info("Coach qualifications updated.", {
          title: "Added",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      }
    },
    async addEditCoachModel(value) {
      if (value === "Edit") {
        this.editMode = true;
      } else {
        this.resetSelectedCoach();
        this.editMode = false;
      }
      this.showModal("addEditCoach");
    },
    resetSelectedCoach() {
      this.selectedcoachesQualifications = {
        UEFA_A: 0,
        UEFA_B: 0,
        UEFA_C: 0,
        UEFA_Futsal_B: 0,
        UEFA_Goalkeeper_A: 0,
        UEFA_Goalkeeper_B: 0,
        UEFA_Pro: 0,
        details: "",
        youth_A_Elite: 0,
        youth_B_Elite: 0,
      };
      this.editMode = false;
    },
    setHeaderUserData() {
      if (this.getProfile !== null) {
        this.userHeaderData = this.getProfile;
      }
    },
    showModal(modelId) {
      // Vue 3 migration: use boolean properties instead of $bvModal.show
      switch (modelId) {
        case "makeCodPDFModal":
          this.showMakeCodPDFModal = true;
          break;
        case "makeSelfDeclarationPDFModal":
          this.showMakeSelfDeclarationPDFModal = true;
          break;
        case "performanceTargetsModal":
          this.showPerformanceTargetsModal = true;
          break;
        case "addEditCPD":
          this.showAddEditCPD = true;
          break;
        case "addEditCoach":
          this.showAddEditCoach = true;
          break;
        case "addHomeworkModal":
          this.showAddHomeworkModal = true;
          break;
        case "jobDescriptionModal":
          this.showJobDescriptionModal = true;
          break;
        case "codeOfConductModal":
          this.showCodeOfConductModal = true;
          break;
        case "selfDeclarationModal":
          this.showSelfDeclarationModal = true;
          break;
      }
    },
    formatMatchDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    formatDateForHuman(date) {
      return date !== undefined && moment(date).isValid()
        ? moment(date).format("MMMM Do YYYY")
        : "";
    },
    getAllTeamsIdsFromTeamsEvents() {
      return this.clubTeams.map((event) => event.id);
    },
    async getAllTeamsPastResults(
      gameStartDateAndTime,
      gameEndDateAndTime,
      allTeamsIds,
    ) {
      const data = {
        action: "getAllTeamsPastResults",
        teamIds: allTeamsIds,
        gameStartDateAndTime: gameStartDateAndTime,
        gameEndDateAndTime: gameEndDateAndTime,
      };

      const responce = await Games.find(data).catch((error) => {
        console.log(error);
      });

      if (responce.data.length > 0) {
        this.allTeamsGameResultsData = responce.data;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.tabs-wrapper {
  .tab-content {
    overflow: scroll;
  }
}

.first-aid-cert-image {
  a {}

  img {
    margin: 1rem 0 !important;
  }
}

.first-aid-image-upload {
  border: 1px solid #dddddd;
  padding: 1rem;
  margin: 1rem 0;
}

.team-logo {
  margin-bottom: 1rem;
}

.job-description {
  margin-top: 2rem;
}

.coaches-missing-info {
  padding: 2rem;

  .compliance-summary {
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
    margin-bottom: 1.5rem;

    .compliance-stat {
      background: #f8f9fa;
      border-radius: 8px;
      padding: 1rem 1.5rem;
      text-align: center;
      min-width: 120px;
      border-left: 4px solid #6c757d;

      .stat-number {
        display: block;
        font-size: 1.8rem;
        font-weight: bold;
        line-height: 1.2;
      }

      .stat-label {
        display: block;
        font-size: 0.8rem;
        color: #6c757d;
      }

      &.compliance-good {
        border-left-color: #28a745;
        .stat-number { color: #28a745; }
      }

      &.compliance-warning {
        border-left-color: #ffc107;
        .stat-number { color: #e0a800; }
      }

      &.compliance-danger {
        border-left-color: #dc3545;
        .stat-number { color: #dc3545; }
      }
    }
  }

  .export-buttons {
    display: flex;
    gap: 0.5rem;

    .btn {
      display: flex;
      align-items: center;
      gap: 0.3rem;
    }
  }

  .amber-warning {
    color: #e0a800;
    font-weight: 600;
  }
}

.list-view-wrapper {
  display: block;
}

.grid-view-wrapper {
  display: flex;
  gap: 1rem;
}

.list {
  display: flex;
  gap: 1rem;
  align-items: center;
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #c3cdd5;

  img {
    width: 2rem;
  }

  h3 {
    margin: 0;
    text-transform: none;
  }

  .doc-buttons {
    margin: 0;
  }
}

.grid-list {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 2rem;
  border-bottom: 1px dashed #c3cdd5;

  .btn-outline-secondary {
    border: none !important;
  }
}

.player-report-content {
  margin-top: 1rem;
  width: 100%;
  height: 50rem;

  iframe {
    width: 100%;
    height: 100%;
  }

  .form__item {
    display: grid;
  }
}

.document {
  max-width: 14rem;
  text-align: center;
  padding: 1rem;
  margin: 1rem;
  border-radius: 4px;
  box-shadow: 0 4px 16px rgba(138, 138, 138, 0.3);
  border: 1px solid transparent;

  &:hover,
  &:focus {
    border: 1px solid #a1152f;
  }

  h3 {
    margin-top: 1rem;
    font-size: 1rem;
    overflow: hidden;
    white-space: nowrap;
    text-transform: inherit;
  }

  img {
    width: 40%;
  }
}

.doc-buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-top: 1rem;

  svg {
    border: 1px solid #c3cdd5;
    padding: 0.3rem;
    font-size: 1.7rem;

    &:hover,
    &:focus {
      cursor: pointer;
      background: #eaeff3;
    }
  }
}

.info-details {
  border: 1px solid #e8923f;
  padding: 1rem;
}

section.section-form-style {
  border: 1px solid #dee2e6;
  padding: 1rem;
  margin: 1rem 0;
}

input#hours,
input#total_hours {
  width: 5rem;
}

.signatureWrapper {
  div {
    border: 1px solid #d6dadd;
    margin-bottom: 1rem;
  }

  div.player-game-responce {
    border: none;
  }
}

.qualifications-data {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 1rem;
}

.qualifications-wrapper,
.numbers-dates,
.continuous-professional-development {
  border: 1px solid #c3cdd5;
  border-radius: 4px;
  padding: 2rem;
  margin-bottom: 2rem;

  img {
    width: 6rem;
    display: block;
    margin: 0 auto 1rem auto;
  }
}

.continuous-professional-development {
  .cpd-item-wrapper {
    background: #fbfdff;
    padding: 1rem;
    margin: 1rem 0;
    height: 20.3rem;
    overflow: scroll;
    border: 1px solid #c3cdd5;

    .cpd-item {
      border: 1px solid #c3cdd5;
      padding: 1rem;
      margin-bottom: 0.5rem;
      border-radius: 4px;
      display: flex;
      flex-wrap: wrap;
      gap: 1rem;
      justify-content: space-between;
      background: white;

      p,
      button {
        margin: 0;
      }

      span {
        display: block;
        font-size: 0.8rem;
      }
    }
  }

  .total-hours {
    margin: 0;
    font-size: 2rem;
    font-weight: bold;
  }

  .small-text {
    font-size: 0.8rem;
  }
}

.numbers-dates {
  p {
    span {
      display: block;
      font-weight: bold;
    }
  }
}

.intro-header {
  border: none;
}

.number-of-results {
  width: 100%;
}

.qualifications-wrapper {
  margin-bottom: 2rem;
}

.targets {
  border: 1px solid #efefef;
  padding: 1rem;
  border-radius: 4px;
  margin-bottom: 1rem;

  h4 {
    font-size: 1rem;
  }

  .target-outline {
    img {
      width: 2rem;
    }

    button {
      margin-top: 1rem;
      display: block;
    }
  }
}
</style>
